import { checkSessionExpiry } from "../../assets";

function request(actionType, response) {
  const isExpired = checkSessionExpiry();
  if (isExpired) {
    return {
      type: USER_REQUEST.SET_SESSION_EXPIRE_STATE,
      payload: true,
    };
  } else {
    return {
      type: actionType,
    };
  }
}

function success(actionType, response, info) {
  return {
    type: actionType,
    payload: response,
    info: info,
  };
}

function failure(actionType, error) {
  return {
    type: actionType,
    payload: error,
  };
}

const USER_REQUEST = {
  USER_SIGNIN_REQUEST: "USER_SIGNIN_REQUEST",
  USER_SIGNIN_SUCCESS: "USER_SIGNIN_SUCCESS",
  USER_SIGNIN_FAILURE: "USER_SIGNIN_FAILURE",

  LOGIN_COVIS_TOUR_REQUEST: "LOGIN_COVIS_TOUR_REQUEST",
  LOGIN_COVIS_TOUR_SUCCESS: "LOGIN_COVIS_TOUR_SUCCESS",
  LOGIN_COVIS_TOUR_FAILURE: "LOGIN_COVIS_TOUR_FAILURE",

  GET_TEAMLEADS_REQUEST: "GET_TEAMLEADS_REQUEST",
  GET_TEAMLEADS_SUCCESS: "GET_TEAMLEADS_SUCCESS",
  GET_TEAMLEADS_FAILURE: "GET_TEAMLEADS_FAILURE",

  GET_TEAM_MEMBERS_REQUEST: "GET_TEAM_MEMBERS",
  GET_TEAM_MEMBERS_SUCCES: "GET_TEAM_MEMBERS_SUCCES",
  GET_TEAM_MEMBERS_FAILURE: "GET_TEAM_MEMBERS_FAILURE",

  GET_EMPLOYEES_SELECTLIST_REQUEST: "GET_EMPLOYEES_SELECTLIST_REQUEST",
  GET_EMPLOYEES_SELECTLIST_SUCCESS: "GET_EMPLOYEES_SELECTLIST_SUCCESS",
  GET_EMPLOYEES_SELECTLIST_FAILURE: "GET_EMPLOYEES_SELECTLIST_FAILURE",

  GET_EMPLOYEES_LIST_REQUEST: "GET_EMPLOYEES_LIST_REQUEST",
  GET_EMPLOYEES_LIST_SUCCESS: "GET_EMPLOYEES_LIST_SUCCESS",
  GET_EMPLOYEES_LIST_FAILURE: "GET_EMPLOYEES_LIST_FAILURE",

  UPDATE_DEPARTMENT_REQUEST: "UPDATE_DEPARTMENT_REQUEST",
  UPDATE_DEPARTMENT_SUCCESS: "UPDATE_DEPARTMENT_SUCCESS",
  UPDATE_DEPARTMENT_FAILURE: "UPDATE_DEPARTMENT_FAILURE",

  GET_EMPLOYEES_SELECT_LIST_BY_ROLE_REQUEST:
    "GET_EMPLOYEES_SELECT_LIST_BY_ROLE_REQUEST",
  GET_EMPLOYEES_SELECT_LIST_BY_ROLE_SUCCESS:
    "GET_EMPLOYEES_SELECT_LIST_BY_ROLE_SUCCESS",
  GET_EMPLOYEES_SELECT_LIST_BY_ROLE_FAILURE:
    "GET_EMPLOYEES_SELECT_LIST_BY_ROLE_FAILURE",
  SET_SESSION_EXPIRE_STATE: "SET_SESSION_EXPIRE_STATE",
  SET_LANDING_MODAL_STATE: "SET_LANDING_MODAL_STATE",
  SET_LOADING_TOUR_STATE: "SET_LOADING_TOUR_STATE",
};
const UPDATE_USER = "UPDATE_USER";
const SCHEDULER_REQUEST = {
  SCHEDULER_DATA_REQUEST: "SCHEDULER_DATA_REQUEST",
  SCHEDULER_DATA_SUCCESS: "SCHEDULER_DATA_SUCCESS",
  SCHEDULER_DATA_FAILURE: "SCHEDULER_DATA_FAILURE",
  UPDATE_TASK_DUEDATE_REQUEST: "UPDATE_TASK_DUEDATE_REQUEST",
  UPDATE_TASK_DUEDATE_SUCCESS: "UPDATE_TASK_DUEDATE_SUCCESS",
  UPDATE_TASK_DUEDATE_FAILURE: "UPDATE_TASK_DUEDATE_FAILURE",
  ADD_SCHEDULER_EVENT_REQUEST: "ADD_SCHEDULER_EVENT_REQUEST",
  ADD_SCHEDULER_EVENT_SUCCESS: "ADD_SCHEDULER_EVENT_SUCCESS",
  ADD_SCHEDULER_EVENT_FAILURE: "ADD_SCHEDULER_EVENT_FAILURE",
  DELETE_SCHEDULER_EVENT_REQUEST: "DELETE_SCHEDULER_EVENT_REQUEST",
  DELETE_SCHEDULER_EVENT_SUCCESS: "DELETE_SCHEDULER_EVENT_SUCCESS",
  DELETE_SCHEDULER_EVENT_FAILURE: "DELETE_SCHEDULER_EVENT_FAILURE",
  EDIT_SCHEDULER_EVENT_REQUEST: "EDIT_SCHEDULER_EVENT_REQUEST",
  EDIT_SCHEDULER_EVENT_SUCCESS: "EDIT_SCHEDULER_EVENT_SUCCESS",
  EDIT_SCHEDULER_EVENT_FAILURE: "EDIT_SCHEDULER_EVENT_FAILURE",

  //GET_PROJECT_LOOKUP_REQUEST: "GET_PROJECT_LOOKUP_REQUEST",
  GET_PROJECT_LOOKUP_SUCCESS: "GET_PROJECT_LOOKUP_SUCCESS",
  //GET_PROJECT_LOOKUP_FAILURE: "GET_PROJECT_LOOKUP_FAILURE",

  //GET_USER_LOOKUP_REQUEST: "GET_USER_LOOKUP_REQUEST",
  GET_USER_LOOKUP_SUCCESS: "GET_USER_LOOKUP_SUCCESS",
  //GET_USER_LOOKUP_FAILURE: "GET_USER_LOOKUP_FAILURE",

  //GET_DEPARTMENT_LOOKUP_REQUEST: "GET_DEPARTMENT_LOOKUP_REQUEST",
  GET_DEPARTMENT_LOOKUP_SUCCESS: "GET_DEPARTMENT_LOOKUP_SUCCESS",
  //GET_DEPARTMENT_LOOKUP_FAILURE: "GET_DEPARTMENT_LOOKUP_FAILURE",

  //GET_TEAM_LOOKUP_REQUEST: "GET_TEAM_LOOKUP_REQUEST",
  GET_TEAM_LOOKUP_SUCCESS: "GET_TEAM_LOOKUP_SUCCESS",
  //GET_TEAM_LOOKUP_FAILURE: "GET_TEAM_LOOKUP_FAILURE",

  GET_TASK_DETAILS_REQUEST: "GET_TASK_DETAILS_REQUEST",
  GET_TASK_DETAILS_SUCCESS: "GET_TASK_DETAILS_SUCCESS",
  GET_TASK_DETAILS_FAILURE: "GET_TASK_DETAILS_FAILURE",
};

const ZOOM = {
  GET_ALL_MEETINGS_REQUEST: "GET_ALL_MEETINGS_REQUEST",
  GET_ALL_MEETINGS_SUCCESS: "GET_ALL_MEETINGS_SUCCESS",
  GET_ALL_MEETINGS_FAILURE: "GET_ALL_MEETINGS_FAILURE",

  CREATE_INSTANT_MEETING_REQUEST: "CREATE_INSTANT_MEETING_REQUEST",
  CREATE_INSTANT_MEETING_SUCCESS: "CREATE_INSTANT_MEETING_SUCCESS",
  CREATE_INSTANT_MEETING_FAILURE: "CREATE_INSTANT_MEETING_FAILURE",

  CREATE_SCHEDULE_MEETING_REQUEST: "CREATE_SCHEDULE_MEETING_REQUEST",
  CREATE_SCHEDULE_MEETING_SUCCESS: "CREATE_SCHEDULE_MEETING_SUCCESS",
  CREATE_SCHEDULE_MEETING_FAILURE: "CREATE_SCHEDULE_MEETING_FAILURE",

  UPDATE_SCHEDULE_MEETING_REQUEST: "UPDATE_SCHEDULE_MEETING_REQUEST",
  UPDATE_SCHEDULE_MEETING_SUCCESS: "UPDATE_SCHEDULE_MEETING_SUCCESS",
  UPDATE_SCHEDULE_MEETING_FAILURE: "UPDATE_SCHEDULE_MEETING_FAILURE",

  ZOOM_OAUTH_REQUEST: "ZOOM_OAUTH_REQUEST",
  ZOOM_OAUTH_SUCCESS: "ZOOM_OAUTH_SUCCESS",
  ZOOM_OAUTH_FAILURE: "ZOOM_OAUTH_FAILURE",

  GET_SINGLE_MEETING_REQUEST: "GET_SINGLE_MEETING_REQUEST",
  GET_SINGLE_MEETING_SUCCESS: "GET_SINGLE_MEETING_SUCCESS",
  GET_SINGLE_MEETING_FAILURE: "GET_SINGLE_MEETING_FAILURE",
};
const EXPENSE_REQUEST = {
  GET_EXPENSE_REQUEST: "GET_EXPENSE_REQUEST",
  GET_EXPENSE_SUCCESS: "GET_EXPENSE_SUCCESS",
  GET_EXPENSE_FAILURE: "GET_EXPENSE_FAILURE",
  ADD_EXPENSE_REQUEST: "ADD_EXPENSE_REQUEST",
  ADD_EXPENSE_RESET: "ADD_EXPENSE_RESET",
  ADD_EXPENSE_SUCCESS: "ADD_EXPENSE_SUCCESS",
  ADD_EXPENSE_FAILURE: "ADD_EXPENSE_FAILURE",
  DELETE_EXPENSE_REQUEST: "DELETE_EXPENSE_REQUEST",
  DELETE_EXPENSE_SUCCESS: "DELETE_EXPENSE_SUCCESS",
  DELETE_EXPENSE_FAILURE: "DELETE_EXPENSE_FAILURE",
  GET_EXPENSE_TYPE_REQUEST: "GET_EXPENSE_TYPE_REQUEST",
  GET_EXPENSE_TYPE_SUCCESS: "GET_EXPENSE_TYPE_SUCCESS",
  GET_EXPENSE_TYPE_FAILURE: "GET_EXPENSE_TYPE_FAILURE",
  ADD_EXPENSE_TYPE_REQUEST: "ADD_EXPENSE_TYPE_REQUEST",
  ADD_EXPENSE_TYPE_SUCCESS: "ADD_EXPENSE_TYPE_SUCCESS",
  ADD_EXPENSE_TYPE_FAILURE: "ADD_EXPENSE_TYPE_FAILURE",
  DELETE_EXPENSE_TYPE_REQUEST: "DELETE_EXPENSE_TYPE_REQUEST",
  DELETE_EXPENSE_TYPE_SUCCESS: "DELETE_EXPENSE_TYPE_SUCCESS",
  DELETE_EXPENSE_TYPE_FAILURE: "DELETE_EXPENSE_TYPE_FAILURE",
  EDIT_EXPENSE_TYPE_REQUEST: "EDIT_EXPENSE_TYPE_REQUEST",
  EDIT_EXPENSE_TYPE_SUCCESS: "EDIT_EXPENSE_TYPE_SUCCESS",
  EDIT_EXPENSE_TYPE_FAILURE: "EDIT_EXPENSE_TYPE_FAILURE",
  GET_SUBEXPENSE_REQUEST: "GET_SUBEXPENSE_REQUEST",
  GET_SUBEXPENSE_SUCCESS: "GET_SUBEXPENSE_SUCCESS",
  GET_SUBEXPENSE_FAILURE: "GET_SUBEXPENSE_FAILURE",
  ADD_SUBEXPENSE_REQUEST: "ADD_SUBEXPENSE_REQUEST",
  ADD_SUBEXPENSE_SUCCESS: "ADD_SUBEXPENSE_SUCCESS",
  ADD_SUBEXPENSE_FAILURE: "ADD_SUBEXPENSE_FAILURE",
  EDIT_SUBEXPENSE_REQUEST: "EDIT_SUBEXPENSE_REQUEST",
  EDIT_SUBEXPENSE_SUCCESS: "EDIT_SUBEXPENSE_SUCCESS",
  EDIT_SUBEXPENSE_FAILURE: "EDIT_SUBEXPENSE_FAILURE",
  DELETE_SUBEXPENSE_REQUEST: "DELETE_SUBEXPENSE_REQUEST",
  DELETE_SUBEXPENSE_SUCCESS: "DELETE_SUBEXPENSE_SUCCESS",
  DELETE_SUBEXPENSE_FAILURE: "DELETE_SUBEXPENSE_FAILURE",
};

const INVOICE_REQUEST = {
  GET_INVOICE_REQUEST: "GET_INVOICE_REQUEST",
  GET_INVOICE_SUCCESS: "GET_INVOICE_SUCCESS",
  GET_INVOICE_FAILURE: "GET_INVOICE_FAILURE",

  ADD_INVOICE_REQUEST: "ADD_INVOICE_REQUEST",
  ADD_INVOICE_SUCCESS: "ADD_INVOICE_SUCCESS",
  ADD_INVOICE_FAILURE: "ADD_INVOICE_FAILURE",

  DELETE_INVOICE_REQUEST: "DELETE_INVOICE_REQUEST",
  DELETE_INVOICE_SUCCESS: "DELETE_INVOICE_SUCCESS",
  DELETE_INVOICE_FAILURE: "DELETE_INVOICE_FAILURE",
};
const INCOME_REQUEST = {
  GET_INCOME_TYPE_REQUEST: "GET_INCOME_TYPE_REQUEST",
  GET_INCOME_TYPE_SUCCESS: "GET_INCOME_TYPE_SUCCESS",
  GET_INCOME_TYPE_FAILURE: "GET_INCOME_TYPE_FAILURE",
  ADD_INCOME_TYPE_REQUEST: "ADD_INCOME_TYPE_REQUEST",
  ADD_INCOME_TYPE_SUCCESS: "ADD_INCOME_TYPE_SUCCESS",
  ADD_INCOME_TYPE_FAILURE: "ADD_INCOME_TYPE_FAILURE",
  ADD_INCOME_RESET: "ADD_EXPENSE_RESET",
  DELETE_INCOME_TYPE_REQUEST: "DELETE_INCOME_TYPE_REQUEST",
  DELETE_INCOME_TYPE_SUCCESS: "DELETE_INCOME_TYPE_SUCCESS",
  DELETE_INCOME_TYPE_FAILURE: "DELETE_INCOME_TYPE_FAILURE",
  EDIT_INCOME_TYPE_REQUEST: "EDIT_INCOME_TYPE_REQUEST",
  EDIT_INCOME_TYPE_SUCCESS: "EDIT_INCOME_TYPE_SUCCESS",
  EDIT_INCOME_TYPE_FAILURE: "EDIT_INCOME_TYPE_FAILURE",
  ADD_INCOME_REQUEST: "ADD_INCOME_REQUEST",
  ADD_INCOME_SUCCESS: "ADD_INCOME_SUCCESS",
  ADD_INCOME_FAILURE: "ADD_INCOME_FAILURE",
  GET_INCOME_REQUEST: "GET_INCOME_REQUEST",
  GET_INCOME_SUCCESS: "GET_INCOME_SUCCESS",
  GET_INCOME_FAILURE: "GET_INCOME_FAILURE",
  DELETE_INCOME_REQUEST: "DELETE_INCOME_REQUEST",
  DELETE_INCOME_SUCCESS: "DELETE_INCOME_SUCCESS",
  DELETE_INCOME_FAILURE: "DELETE_INCOME_FAILURE",
};
const SALARY_REQUEST = {
  GET_SALARY_REQUEST: "GET_SALARY_REQUEST",
  GET_SALARY_SUCCESS: "GET_SALARY_SUCCESS",
  GET_SALARY_FAILURE: "GET_SALARY_FAILURE",
};
const PAYMENT_METHOD_REQUEST = {
  GET_PAYMENT_METHOD_REQUEST: "GET_PAYMENT_METHOD_REQUEST",
  GET_PAYMENT_METHOD_SUCCESS: "GET_PAYMENT_METHOD_SUCCESS",
  GET_PAYMENT_METHOD_FAILURE: "GET_PAYMENT_METHOD_FAILURE",
  ADD_PAYMENT_METHOD_REQUEST: "ADD_PAYMENT_METHOD_REQUEST",
  ADD_PAYMENT_METHOD_SUCCESS: "ADD_PAYMENT_METHOD_SUCCESS",
  ADD_PAYMENT_METHOD_FAILURE: "ADD_PAYMENT_METHOD_FAILURE",
  DELETE_PAYMENT_METHOD_REQUEST: "DELETE_PAYMENT_METHOD_REQUEST",
  DELETE_PAYMENT_METHOD_SUCCESS: "DELETE_PAYMENT_METHOD_SUCCESS",
  DELETE_PAYMENT_METHOD_FAILURE: "DELETE_PAYMENT_METHOD_FAILURE",
  EDIT_PAYMENT_METHOD_REQUEST: "EDIT_PAYMENT_METHOD_REQUEST",
  EDIT_PAYMENT_METHOD_SUCCESS: "EDIT_PAYMENT_METHOD_SUCCESS",
  EDIT_PAYMENT_METHOD_FAILURE: "EDIT_PAYMENT_METHOD_FAILURE",
  ADD_PAYMENT_METHOD_RESET: "ADD_PAYMENT_METHOD_RESET",
};

const PROJECT_BACKLOG = {
  GET_PROJECT_BACKLOG_REQUEST: "GET_PROJECT__BACKLOG_REQUEST",
  GET_PROJECT_BACKLOG_SUCCESS: "GET_PROJECT__BACKLOG_SUCCESS",
  GET_PROJECT_BACKLOG_FAILURE: "GET_PROJECT_BACKLOG_FAILURE",

  ADD_PROJECT_BACKLOG_REQUEST: "ADD_PROJECT__BACKLOG_REQUEST",
  ADD_PROJECT_BACKLOG_SUCCESS: "ADD_PROJECT__BACKLOG_SUCCESS",
  ADD_PROJECT_BACKLOG_FAILURE: "ADD_PROJECT_BACKLOG_FAILURE",

  EDIT_PROJECT_BACKLOG_REQUEST: "EDIT_PROJECT__BACKLOG_REQUEST",
  EDIT_PROJECT_BACKLOG_SUCCESS: "EDIT_PROJECT__BACKLOG_SUCCESS",
  EDIT_PROJECT_BACKLOG_FAILURE: "EDIT_PROJECT_BACKLOG_FAILURE",

  DELETE_PROJECT_BACKLOG_REQUEST: "DELETE_PROJECT__BACKLOG_REQUEST",
  DELETE_PROJECT_BACKLOG_SUCCESS: "DELETE_PROJECT__BACKLOG_SUCCESS",
  DELETE_PROJECT_BACKLOG_FAILURE: "DELETE_PROJECT_BACKLOG_FAILURE",

  ADD_TASK_IN_MILESTONE_REQUEST: "ADD_TASK_IN_MILESTONE_REQUEST",
  ADD_TASK_IN_MILESTONE_SUCCESS: "ADD_TASK_IN_MILESTONE_SUCCESS",
  ADD_TASK_IN_MILESTONE_FAILURE: "ADD_TASK_IN_MILESTONE_FAILURE",

  FILTER_TASK_BY_MILESTONE_REQUEST: "FILTER_TASK_BY_MILESTONE_REQUEST",
  FILTER_TASK_BY_MILESTONE_SUCCESS: "FILTER_TASK_BY_MILESTONE_SUCCESS",
  FILTER_TASK_BY_MILESTONE_FAILURE: "FILTER_TASK_BY_MILESTONE_FAILURE",

  MOVE_BACKLOG_REQUEST: "MOVE_BACKLOG_REQUEST",
  MOVE_BACKLOG_SUCCESS: "MOVE_BACKLOG_SUCCESS",
  MOVE_BACKLOG_FAILURE: "MOVE_BACKLOG_FAILURE",
};

const PROJECT_REQUEST = {
  REMOVE_USER_FROM_PROJECT_REQUEST: "REMOVE_USER_FROM_PROJECT_REQUEST",
  REMOVE_USER_FROM_PROJECT_SUCCESS: "REMOVE_USER_FROM_PROJECT_SUCCESS",
  REMOVE_USER_FROM_PROJECT_FAILURE: "REMOVE_USER_FROM_PROJECT_FAILURE",

  GET_PROJECT_REQUEST: "GET_PROJECT_REQUEST",
  GET_NEXT_PROJECT_REQUEST: "GET_NEXT_PROJECT_REQUEST",
  GET_PROJECT_SUCCESS: "GET_PROJECT_SUCCESS",

  GET_PROJECT_ON_RELOAD_REQUEST: "GET_PROJECT_ON_RELOAD_REQUEST",
  GET_PROJECT_ON_RELOAD_FAILURE: "GET_PROJECT_ON_RELOAD_FAILURE",
  GET_PROJECT_ON_RELOAD_SUCCESS: "GET_PROJECT_ON_RELOAD_SUCCESS",

  GET_NEXT_PROJECT_SUCCESS: "GET_NEXT_PROJECT_SUCCESS",
  GET_PROJECT_FAILURE: "GET_PROJECT_FAILURE",
  GET_NEXT_PROJECT_FAILURE: "GET_NEXT_PROJECT_FAILURE",
  ADD_PROJECT_REQUEST: "ADD_PROJECT_REQUEST",
  ADD_PROJECT_SUCCESS: "ADD_PROJECT_SUCCESS",
  ADD_PROJECT_FAILURE: "ADD_PROJECT_FAILURE",
  EDIT_PROJECT_REQUEST: "EDIT_PROJECT_REQUEST",
  EDIT_PROJECT_SUCCESS: "EDIT_PROJECT_SUCCESS",
  EDIT_PROJECT_FAILURE: "EDIT_PROJECT_FAILURE",
  ADD_PROJECT_TASK_REQUEST: "ADD_PROJECT_TASK_REQUEST",
  ADD_PROJECT_TASK_SUCCESS: "ADD_PROJECT_TASK_SUCCESS",
  ADD_PROJECT_TASK_FAILURE: "ADD_PROJECT_TASK_FAILURE",
  DELETE_PROJECT_REQUEST: "DELETE_PROJECT_REQUEST",
  DELETE_PROJECT_SUCCESS: "DELETE_PROJECT_SUCCESS",
  DELETE_PROJECT_FAILURE: "DELETE_PROJECT_FAILURE",
  SET_CURRENT_PROJECT_SUCCESS: "SET_CURRENT_PROJECT_SUCCESS",

  GET_PROJECT_SELECT_LIST_BY_ROLE_REQUEST:
    "GET_PROJECT_SELECT_LIST_BY_ROLE_REQUEST",
  GET_PROJECT_SELECT_LIST_BY_ROLE_SUCCESS:
    "GET_PROJECT_SELECT_LIST_BY_ROLE_SUCCESS",
  GET_PROJECT_SELECT_LIST_BY_ROLE_FAILURE:
    "GET_PROJECT_SELECT_LIST_BY_ROLE_FAILURE",

  GET_DELETE_PROJECT_LIST_REQUEST: "GET_DELETE_PROJECT_LIST_REQUEST",
  GET_DELETE_PROJECT_LIST_SUCCESS: "GET_DELETE_PROJECT_LIST_SUCCESS",
  GET_DELETE_PROJECT_LIST_FAILURE: "GET_DELETE_PROJECT_LIST_FAILURE",

  RESTORE_DELETE_PROJECT_REQUEST: "RESTORE_DELETE_PROJECT_REQUEST",
  RESTORE_DELETE_PROJECT_SUCCESS: "RESTORE_DELETE_PROJECT_SUCCESS",
  RESTORE_DELETE_PROJECT_FAILURE: "RESTORE_DELETE_PROJECT_FAILURE",

  EMPTY_TRASH_PROJECT_REQUEST: "EMPTY_TRASH_PROJECT_REQUEST",
  EMPTY_TRASH_PROJECT_SUCCESS: "EMPTY_TRASH_PROJECT_SUCCESS",
  EMPTY_TRASH_PROJECT_FAILURE: "EMPTY_TRASH_PROJECT_FAILURE",

  DELETE_TRASH_PROJECT_REQUEST: "DELETE_TRASH_PROJECT_REQUEST",
  DELETE_TRASH_PROJECT_SUCCESS: "DELETE_TRASH_PROJECT_SUCCESS",
  DELETE_TRASH_PROJECT_FAILURE: "DELETE_TRASH_PROJECT_FAILURE",

  GET_PROJECTS_BY_EMPLOYEE_REQUEST: "GET_PROJECTS_BY_EMPLOYEE_REQUEST",
  GET_PROJECTS_BY_EMPLOYEE_SUCCESS: "GET_PROJECTS_BY_EMPLOYEE_SUCCESS",
  GET_PROJECTS_BY_EMPLOYEE_FAILURE: "GET_PROJECTS_BY_EMPLOYEE_FAILURE",

  GET_EMPLOYEE_TASKS_FAILURE: "GET_EMPLOYEE_TASKS_FAILURE",
  GET_EMPLOYEE_TASKS_SUCCESS: "GET_EMPLOYEE_TASKS_SUCCESS",
  GET_EMPLOYEE_TASKS_REQUEST: "GET_EMPLOYEE_TASKS_REQUEST",
};
const PROJECTMILESTONE = {
  FILTER_PROJECT_MILESTONE: "FILTER_PROJECT_MILESTONE",
  CHANGE_RELEASE_STATUS_SUCCESS: "CHANGE_RELEASE_STATUS_SUCCESS",
  CHANGE_RELEASE_STATUS_REQUEST: "CHANGE_RELEASE_STATUS_REQUEST",
  CHANGE_RELEASE_STATUS_FAILURE: "CHANGE_RELEASE_STATUS_FAILURE",

  ADD_COMMENT_IN_TASK_SUCCESS: "ADD_COMMENT_IN_TASK_SUCCESS",
  ADD_COMMENT_IN_TASK_FAILURE: "ADD_COMMENT_IN_TASK_FAILURE",
  ADD_COMMENT_IN_TASK_REQUEST: "ADD_COMMENT_IN_TASK_REQUEST",

  DELETE_COMMENT_IN_TASK_SUCCESS: "DELETE_COMMENT_IN_TASK_SUCCESS",
  DELETE_COMMENT_IN_TASK_FAILURE: "DELETE_COMMENT_IN_TASK_FAILURE",
  DELETE_COMMENT_IN_TASK_REQUEST: "DELETE_COMMENT_IN_TASK_REQUEST",

  GET_COMMENT_IN_TASK_SUCCESS: "GET_COMMENT_IN_TASK_SUCCESS",
  GET_COMMENT_IN_TASK_FAILURE: "GET_COMMENT_IN_TASK_FAILURE",
  GET_COMMENT_IN_TASK_REQUEST: "GET_COMMENT_IN_TASK_REQUEST",

  GET_PROJECT_MILESTONE_REQUEST: "GET_PROJECT_MILESTONE_REQUEST",
  GET_PROJECT_MILESTONE_SUCCESS: "GET_PROJECT_MILESTONE_SUCCESS",
  GET_PROJECT_MILESTONE_FAILURE: "GET_PROJECT_MILESTONE_FAILURE",

  GET_PROJECT_MILESTONES_SELECTLIST_REQUEST:
    "GET_PROJECT_MILESTONES_SELECTLIST_REQUEST",
  GET_PROJECT_MILESTONES_SELECTLIST_SUCCESS:
    "GET_PROJECT_MILESTONES_SELECTLIST_SUCCESS",
  GET_PROJECT_MILESTONES_SELECTLIST_FAILURE:
    "GET_PROJECT_MILESTONES_SELECTLIST_FAILURE",

  CHANGE_TASK_MILESTONE_REQUEST: "CHANGE_TASK_MILESTONE_REQUEST",
  CHANGE_TASK_MILESTONE_SUCCESS: "CHANGE_TASK_MILESTONE_SUCCESS",
  CHANGE_TASK_MILESTONE_FAILURE: "CHANGE_TASK_MILESTONE_FAILURE",

  ADD_PROJECT_MILESTONE_REQUEST: "ADD_PROJECT_MILESTONE_REQUEST",
  ADD_PROJECT_MILESTONE_SUCCESS: "ADD_PROJECT_MILESTONE_SUCCESS",
  ADD_PROJECT_MILESTONE_FAILURE: "ADD_PROJECT_MILESTONE_FAILURE",

  DELETE_PROJECT_MILESTONE_REQUEST: "DELETE_PROJECT_MILESTONE_REQUEST",
  DELETE_PROJECT_MILESTONE_SUCCESS: "DELETE_PROJECT_MILESTONE_SUCCESS",
  DELETE_PROJECT_MILESTONE_FAILURE: "DELETE_PROJECT_MILESTONE_FAILURE",

  CREATE_TASK_IN_MILESTONE_REQUEST: "CREATE_TASK_IN_MILESTONE_REQUEST",
  CREATE_TASK_IN_MILESTONE_SUCCESS: "CREATE_TASK_IN_MILESTONE_SUCCESS",
  CREATE_TASK_IN_MILESTONE_FAILURE: "CREATE_TASK_IN_MILESTONE_FAILURE",

  EDIT_TASK_IN_MILESTONE_REQUEST: "EDIT_TASK_IN_MILESTONE_REQUEST",
  EDIT_TASK_IN_MILESTONE_SUCCESS: "EDIT_TASK_IN_MILESTONE_SUCCESS",
  EDIT_DELETE_TASK_IN_MILESTONE_SUCCESS:
    "EDIT_DELETE_TASK_IN_MILESTONE_SUCCESS",
  EDIT_TASK_IN_MILESTONE_FAILURE: "EDIT_TASK_IN_MILESTONE_FAILURE",

  FETCH_TASK_IN_MILESTONE_REQUEST: "FETCH_TASK_IN_MILESTONE_REQUEST",
  FETCH_TASK_IN_MILESTONE_SUCCESS: "FETCH_TASK_IN_MILESTONE_SUCCESS",
  FETCH_TASK_IN_MILESTONE_FAILURE: "FETCH_TASK_IN_MILESTONE_FAILURE",

  DELETE_TASK_IN_MILESTONE_SUCCESS: "DELETE_TASK_IN_MILESTONE_SUCCESS",

  FILTER_RELEASES_REQUEST: "FILTER_RELEASES_REQUEST",
  FILTER_RELEASES_SUCCESS: "FILTER_RELEASES_SUCCESS",
  FILTER_RELEASES_FAILURE: "FILTER_RELEASES_FAILURE",

  START_SPRINT_REQUEST: "START_SPRINT_REQUEST",
  START_SPRINT_SUCCESS: "START_SPRINT_SUCCESS",
  START_SPRINT_FAILURE: "START_SPRINT_FAILURE",
  CLEAR_START_SPRINT_ERROR: "CLEAR_START_SPRINT_ERROR",

  COMPLETE_SPRINT_IF_TASKS_COMPLETED_REQUEST:
    "COMPLETE_SPRINT_IF_TASKS_COMPLETED_REQUEST",
  COMPLETE_SPRINT_IF_TASKS_COMPLETED_SUCCESS:
    "COMPLETE_SPRINT_IF_TASKS_COMPLETED_SUCCESS",
  COMPLETE_SPRINT_IF_TASKS_COMPLETED_FAILURE:
    "COMPLETE_SPRINT_IF_TASKS_COMPLETED_FAILURE",

  GET_ALL_SPRINTS_WITHOUT_STARTED_SPRINT_REQUEST:
    "GET_ALL_SPRINTS_WITHOUT_STARTED_SPRINT_REQUEST",
  GET_ALL_SPRINTS_WITHOUT_STARTED_SPRINT_SUCCESS:
    "GET_ALL_SPRINTS_WITHOUT_STARTED_SPRINT_SUCCESS",
  GET_ALL_SPRINTS_WITHOUT_STARTED_SPRINT_FAILURE:
    "GET_ALL_SPRINTS_WITHOUT_STARTED_SPRINT_FAILURE",

  MOVE_SPRINT_TASKS_REQUEST: "MOVE_SPRINT_TASKS_REQUEST",
  MOVE_SPRINT_TASKS_SUCCESS: "MOVE_SPRINT_TASKS_SUCCESS",
  MOVE_SPRINT_TASKS_FAILURE: "MOVE_SPRINT_TASKS_FAILURE",

  USER_SELECTED_MILESTONE_REQUEST: "USER_SELECTED_MILESTONE_REQUEST",
  USER_SELECTED_MILESTONE_SUCCESS: "USER_SELECTED_MILESTONE_SUCCESS",
  USER_SELECTED_MILESTONE_FAILURE: "USER_SELECTED_MILESTONE_FAILURE",
};
const EMPLOYEE_REQUEST = {
  GET_EMPLOYEE_REQUEST: "GET_EMPLOYEE_REQUEST",
  GET_EMPLOYEE_SUCCESS: "GET_EMPLOYEE_SUCCESS",
  GET_EMPLOYEE_FAILURE: "GET_EMPLOYEE_FAILURE",

  BLOCK_UNBLOCK_EMPLOYEE_REQUEST: "BLOCK_UNBLOCK_EMPLOYEE_REQUEST",
  BLOCK_UNBLOCK_EMPLOYEE_SUCCESS: "BLOCK_UNBLOCK_EMPLOYEE_SUCCESS",
  BLOCK_UNBLOCK_EMPLOYEE_FAILURE: "BLOCK_UNBLOCK_EMPLOYEE_FAILURE",
};
const LATE_COMING_REQUEST = {
  GET_LIST_REQUEST: "GET_LIST_REQUEST",
  GET_LIST_SUCCESS: "GET_LIST_SUCCESS",
  GET_LIST_FAILURE: "GET_LIST_FAILURE",
};
const LEAVES_REQUEST = {
  GET_LEAVE_TYPE_REQUEST: "GET_LEAVE_TYPE_REQUEST",
  GET_LEAVE_TYPE_SUCCESS: "GET_LEAVE_TYPE_SUCCESS",
  GET_LEAVE_TYPE_FAILURE: "GET_LEAVE_TYPE_FAILURE",
  GET_LEAVES_REQUEST: "GET_LEAVES_REQUEST",
  GET_LEAVES_SUCCESS: "GET_LEAVES_SUCCESS",
  GET_LEAVES_FAILURE: "GET_LEAVES_FAILURE",
  UPDATE_LEAVES_STATUS_REQUEST: "UPDATE_LEAVES_STATUS_REQUEST",
  UPDATE_LEAVES_STATUS_SUCCESS: "UPDATE_LEAVES_STATUS_SUCCESS",
  UPDATE_LEAVES_STATUS_FAILURE: "UPDATE_LEAVES_STATUS_FAILURE",
  LEAVES_REQUEST_RESET: "LEAVES_REQUEST_RESET",
};
const TASK_REQUEST = {
  GET_PROJECT_BOARDS_REQUEST: "GET_PROJECT_BOARDS_REQUEST",
  GET_PROJECT_BOARDS_SUCCESS: "GET_PROJECT_BOARDS_SUCCESS",
  GET_PROJECT_BOARDS_FAILURE: "GET_PROJECT_BOARDS_FAILURE",

  UPDATE_MILESTONE_TASK_COUNTS: "UPDATE_MILESTONE_TASK_COUNTS",

  UPDATE_TASK_BOARDS_ORDER_REQUEST: "UPDATE_TASK_BOARDS_ORDER_REQUEST",
  UPDATE_TASK_BOARDS_ORDER_SUCCESS: "UPDATE_TASK_BOARDS_ORDER_SUCCESS",
  UPDATE_TASK_BOARDS_ORDER_FAILURE: "UPDATE_TASK_BOARDS_ORDER_FAILURE",

  GET_WORKING_HOURS_REQUEST: "GET_WORKING_HOURS_REQUEST",
  GET_WORKING_HOURS_SUCCESS: "GET_WORKING_HOURS_SUCCESS",
  GET_WORKING_HOURS_FAILURE: "GET_WORKING_HOURS_FAILURE",

  GET_NEXT_PROJECT_TASK_BOARDS_REQUEST: "GET_NEXT_PROJECT_TASK_BOARDS_REQUEST",
  GET_NEXT_PROJECT_TASK_BOARDS_SUCCESS: "GET_NEXT_PROJECT_TASK_BOARDS_SUCCESS",
  GET_NEXT_PROJECT_TASK_BOARDS_FAILURE: "GET_NEXT_PROJECT_TASK_BOARDS_FAILURE",

  ADD_TASK_RESET: "ADD_TASK_RESET",
  OPEN_ADD_BOARD_MODAL: "OPEN_ADD_BOARD_MODAL",
  CLOSE_ADD_BOARD_MODAL: "CLOSE_ADD_BOARD_MODAL",
  GET_TASK_BOARD_STATUS_REQUEST: "GET_TASK_BOARD_STATUS_REQUEST",
  GET_TASK_BOARD_STATUS_SUCCESS: "GET_TASK_BOARD_STATUS_SUCCESS",
  GET_TASK_BOARD_STATUS_FAILURE: "GET_TASK_BOARD_STATUS_FAILURE",
  CREATE_TASK_BOARD_REQUEST: "CREATE_TASK_BOARD_REQUEST",
  CREATE_TASK_BOARD_SUCCESS: "CREATE_TASK_BOARD_SUCCESS",
  CREATE_TASK_BOARD_FAILURE: "CREATE_TASK_BOARD_FAILURE",
  EDIT_TASK_BOARD_REQUEST: "EDIT_TASK_BOARD_REQUEST",
  EDIT_TASK_BOARD_SUCCESS: "EDIT_TASK_BOARD_SUCCESS",
  EDIT_TASK_BOARD_FAILURE: "EDIT_TASK_BOARD_FAILURE",
  EDIT_TASK_REQUEST: "EDIT_TASK_REQUEST",
  EDIT_TASK_SUCCESS: "EDIT_TASK_SUCCESS",
  EDIT_TASK_FAILURE: "EDIT_TASK_FAILURE",
  HYDRATE_TASK_DETAIL_SUCCESS: "HYDRATE_TASK_DETAIL_SUCCESS",
  CREATE_TASK_REQUEST: "CREATE_TASK_REQUEST",
  CREATE_TASK_SUCCESS: "CREATE_TASK_SUCCESS",
  CREATE_TASK_FAILURE: "CREATE_TASK_FAILURE",
  DELETE_TASK_REQUEST: "DELETE_TASK_REQUEST",
  DELETE_TASK_SUCCESS: "DELETE_TASK_SUCCESS",
  DELETE_TASK_FAILURE: "DELETE_TASK_FAILURE",
  UPDATE_BULK_TASK_REQUEST: "UPDATE_BULK_TASK_REQUEST",
  UPDATE_BULK_TASK_SUCCESS: "UPDATE_BULK_TASK_SUCCESS",
  UPDATE_BULK_TASK_FAILURE: "UPDATE_BULK_TASK_FAILURE",

  DELETE_TASK_BOARD_REQUEST: "DELETE_TASK_BOARD_REQUEST",
  DELETE_TASK_BOARD_SUCCESS: "DELETE_TASK_BOARD_SUCCESS",
  DELETE_TASK_BOARD_FAILURE: "DELETE_TASK_BOARD_FAILURE",
  CHANGE_TASK_STATUS_REQUEST: "CHANGE_TASK_STATUS_REQUEST",
  CHANGE_TASK_STATUS_SUCCESS: "CHANGE_TASK_STATUS_SUCCESS",
  CHANGE_TASK_STATUS_FAILURE: "CHANGE_TASK_STATUS_FAILURE",
  UPDATE_BOARD_TASK_COUNTS_REQUEST: "UPDATE_BOARD_TASK_COUNTS_REQUEST",

  FILTER_BY_SEVERITY: "FILTER_BY_SEVERITY",
  FILTER_BY_ASSIGNEE: "FILTER_BY_ASSIGNEE",
  FILTER_BY_ME: "FILTER_BY_ME",
  FILTER_BY_PRIORITY: "FILTER_BY_PRIORITY",
  FILTER_BY_CREATED_DATE: "FILTER_BY_CREATED_DATE",
  FILTER_BY_COMPLETED_DATE: "FILTER_BY_COMPLETED_DATE",

  CLEAR_FILTER: "CLEAR_FILTER",
  PROJECT_SELECTED: "PROJECT_SELECTED",
  OPEN_INVITE_MODAL: "OPEN_INVITE_MODAL",
  CLOSE_INVITE_MODAL: "CLOSE_INVITE_MODAL",
  MOVE_KANBAN_COLUMN: "MOVE_KANBAN_COLUMN",

  SEND_INVITE_REQUEST: "SEND_INVITE_LOADING",
  SEND_INVITE_SUCCESS: "SEND_INVITE_SUCCESS",
  SEND_INVITE_FAILURE: "SEND_INVITE_FAILURE",

  USER_LIST_INVITE_REQUEST: "USER_LIST_INVITE_REQUEST",
  USER_LIST_INVITE_SUCCESS: "USER_LIST_INVITE_SUCCESS",
  USER_LIST_INVITE_FAILURE: "USER_LIST_INVITE_FAILURE",

  REMOVE_USER_FROM_PROJECT_REQUEST: "REMOVE_USER_FROM_PROJECT_REQUEST",
  REMOVE_USER_FROM_PROJECT_SUCCESS: "REMOVE_USER_FROM_PROJECT_SUCCESS",
  REMOVE_USER_FROM_PROJECT_FAILURE: "REMOVE_USER_FROM_PROJECT_FAILURE",
  ADD_QA_TEMPLATE_REQUEST: "ADD_QA_TEMPLATE_REQUEST",
  ADD_QA_TEMPLATE_SUCCESS: "ADD_QA_TEMPLATE_SUCCESS",
  ADD_QA_TEMPLATE_FAILURE: "ADD_QA_TEMPLATE_FAILURE",

  UPDATE_QA_TEMPLATE_REQUEST: "UPDATE_QA_TEMPLATE_REQUEST",
  UPDATE_QA_TEMPLATE_SUCCESS: "UPDATE_QA_TEMPLATE_SUCCESS",
  UPDATE_QA_TEMPLATE_FAILURE: "UPDATE_QA_TEMPLATE_FAILURE",

  GET_QA_TEMPLATE_REQUEST: "GET_QA_TEMPLATE_REQUEST",
  GET_QA_TEMPLATE_SUCCESS: "GET_QA_TEMPLATE_SUCCESS",
  GET_QA_TEMPLATE_FAILURE: "GET_QA_TEMPLATE_FAILURE",

  REMOVE_QA_TEMPLATE_REQUEST: "REMOVE_QA_TEMPLATE_REQUEST",
  REMOVE_QA_TEMPLATE_SUCCESS: "REMOVE_QA_TEMPLATE_SUCCESS",
  REMOVE_QA_TEMPLATE_FAILURE: "REMOVE_QA_TEMPLATE_FAILURE",

  GET_COMMENT_IN_KANBAN_SUCCESS: "GET_COMMENT_IN_KANBAN_SUCCESS",
  GET_COMMENT_IN_KANBAN_REQUEST: "GET_COMMENT_IN_KANBAN_REQUEST",
  GET_COMMENT_IN_KANBAN_FAILURE: "GET_COMMENT_IN_KANBAN_FAILURE",

  ADD_COMMENT_IN_KANBAN_SUCCESS: "ADD_COMMENT_IN_KANBAN_SUCCESS",
  ADD_COMMENT_IN_KANBAN_REQUEST: "ADD_COMMENT_IN_KANBAN_REQUEST",
  ADD_COMMENT_IN_KANBAN_FAILURE: "ADD_COMMENT_IN_KANBAN_FAILURE",

  DELETE_COMMENT_IN_KANBAN_SUCCESS: "DELETE_COMMENT_IN_KANBAN_SUCCESS",
  DELETE_COMMENT_IN_KANBAN_REQUEST: "DELETE_COMMENT_IN_KANBAN_REQUEST",
  DELETE_COMMENT_IN_KANBAN_FAILURE: "DELETE_COMMENT_IN_KANBAN_FAILURE",

  GET_TASK_WORKHISTORY_SUCCESS: "GET_TASK_WORKHISTORY_SUCCESS",
  GET_TASK_WORKHISTORY_REQUEST: "GET_TASK_WORKHISTORY_REQUEST",
  GET_TASK_WORKHISTORY_FAILURE: "GET_TASK_WORKHISTORY_FAILURE",

  GET_TASK_WORKLOG_SUCCESS: "GET_TASK_WORKLOG_SUCCESS",
  GET_TASK_WORKLOG_REQUEST: "GET_TASK_WORKLOG_REQUEST",
  GET_TASK_WORKLOG_FAILURE: "GET_TASK_WORKLOG_FAILURE",

  ADD_TASK_WORKLOG_SUCCESS: "ADD_TASK_WORKLOG_SUCCESS",
  ADD_TASK_WORKLOG_REQUEST: "ADD_TASK_WORKLOG_REQUEST",
  ADD_TASK_WORKLOG_FAILURE: "ADD_TASK_WORKLOG_FAILURE",

  DELETE_TASK_ATTACHMENT_SUCCESS: "DELETE_TASK_ATTACHMENT_SUCCESS",
  DELETE_TASK_ATTACHMENT_REQUEST: "DELETE_TASK_ATTACHMENT_REQUEST",
  DELETE_TASK_ATTACHMENT_FAILURE: "DELETE_TASK_ATTACHMENT_FAILURE",

  TASK_RESET_PARTIAL_STATE: "TASK_RESET_PARTIAL_STATE",
};
const LOANS_REQUEST = {
  GET_LOANS_OWN_TO_OTHERS_REQUEST: "GET_LOANS_OWN_TO_OTHERS_REQUEST",
  GET_LOANS_OWN_TO_OTHERS_SUCCESS: "GET_LOANS_OWN_TO_OTHERS_SUCCESS",
  GET_LOANS_OWN_TO_OTHERS_FAILURE: "GET_LOANS_OWN_TO_OTHERS_FAILURE",
  GET_LOANS_OWN_TO_ME_REQUEST: "GET_LOANS_OWN_TO_ME_REQUEST",
  GET_LOANS_OWN_TO_ME_SUCCESS: "GET_LOANS_OWN_TO_ME_SUCCESS",
  GET_LOANS_OWN_TO_ME_FAILURE: "GET_LOANS_OWN_TO_ME_FAILURE",
  ADD_LOAN_REQUEST: "ADD_LOAN_REQUEST",
  ADD_LOAN_SUCCESS: "ADD_LOAN_SUCCESS",
  ADD_LOAN_FAILURE: "ADD_LOAN_FAILURE",
  EDIT_LOAN_REQUEST: "EDIT_LOAN_REQUEST",
  EDIT_LOAN_SUCCESS: "EDIT_LOAN_SUCCESS",
  EDIT_LOAN_FAILURE: "EDIT_LOAN_FAILURE",
  DELETE_LOAN_REQUEST: "DELETE_LOAN_REQUEST",
  DELETE_LOAN_SUCCESS: "DELETE_LOAN_SUCCESS",
  DELETE_LOAN_FAILURE: "DELETE_LOAN_FAILURE",
};
const PROVIDENT_FUND_REQUEST = {
  GET_FUNDS_LIST_REQUEST: "GET_FUNDS_LIST_REQUEST",
  GET_FUNDS_LIST_SUCCESS: "GET_FUNDS_LIST_SUCCESS",
  GET_FUNDS_LIST_FAILURE: "GET_FUNDS_LIST_FAILURE",
  ADD_FUNDS_LIST_REQUEST: "ADD_FUNDS_LIST_REQUEST",
  ADD_FUNDS_LIST_SUCCESS: "ADD_FUNDS_LIST_SUCCESS",
  ADD_FUNDS_LIST_FAILURE: "ADD_FUNDS_LIST_FAILURE",
  EDIT_FUNDS_LIST_REQUEST: "EDIT_FUNDS_LIST_REQUEST",
  EDIT_FUNDS_LIST_SUCCESS: "EDIT_FUNDS_LIST_SUCCESS",
  EDIT_FUNDS_LIST_FAILURE: "EDIT_FUNDS_LIST_FAILURE",
  DELETE_FUNDS_LIST_REQUEST: "DELETE_FUNDS_LIST_REQUEST",
  DELETE_FUNDS_LIST_SUCCESS: "DELETE_FUNDS_LIST_SUCCESS",
  DELETE_FUNDS_LIST_FAILURE: "DELETE_FUNDS_LIST_FAILURE",
};
const ASSET_REQUEST = {
  GET_ASSETS_REQUEST: "GET_ASSETS_REQUEST",
  GET_ASSETS_SUCCESS: "GET_ASSETS_SUCCESS",
  GET_ASSETS_FAILURE: "GET_ASSETS_FAILURE",
  ADD_ASSETS_REQUEST: "ADD_ASSETS_REQUEST",
  ADD_ASSETS_SUCCESS: "ADD_ASSETS_SUCCESS",
  ADD_ASSETS_FAILURE: "ADD_ASSETS_FAILURE",
  DELETE_ASSETS_REQUEST: "DELETE_ASSETS_REQUEST",
  DELETE_ASSETS_SUCCESS: "DELETE_ASSETS_SUCCESS",
  DELETE_ASSETS_FAILURE: "DELETE_ASSETS_FAILURE",
  EDIT_ASSETS_REQUEST: "EDIT_ASSETS_REQUEST",
  EDIT_ASSETS_SUCCESS: "EDIT_ASSETS_SUCCESS",
  EDIT_ASSETS_FAILURE: "EDIT_ASSETS_FAILURE",
  ADD_ASSETS_TYPE_REQUEST: "ADD_ASSETS_TYPE_REQUEST",
  ADD_ASSETS_TYPE_SUCCESS: "ADD_ASSETS_TYPE_SUCCESS",
  ADD_ASSETS_TYPE_FAILURE: "ADD_ASSETS_TYPE_FAILURE",
  DELETE_ASSETS_TYPE_REQUEST: "DELETE_ASSETS_TYPE_REQUEST",
  DELETE_ASSETS_TYPE_SUCCESS: "DELETE_ASSETS_TYPE_SUCCESS",
  DELETE_ASSETS_TYPE_FAILURE: "DELETE_ASSETS_TYPE_FAILURE",
  EDIT_ASSETS_TYPE_REQUEST: "EDIT_ASSETS_TYPE_REQUEST",
  EDIT_ASSETS_TYPE_SUCCESS: "EDIT_ASSETS_TYPE_SUCCESS",
  EDIT_ASSETS_TYPE_FAILURE: "EDIT_ASSETS_TYPE_FAILURE",
  GET_ASSETS_TYPE_REQUEST: "GET_ASSETS_TYPE_REQUEST",
  GET_ASSETS_TYPE_SUCCESS: "GET_ASSETS_TYPE_SUCCESS",
  GET_ASSETS_TYPE_FAILURE: "GET_ASSETS_TYPE_FAILURE",
  GET_ASSETS_TYPE_RESET: "GET_ASSETS_TYPE_RESET",
  RESET_ASSET_TYPE: "RESET_ASSET_TYPE",
};
const GENERAL_REQUEST = {
  SET_UPLOADED_FILE: "SET_UPLOADED_FILE",
  REMOVE_UPLOADED_FILE: "REMOVE_UPLOADED_FILE",
  RESET_UPLOADED_FILE: "RESET_UPLOADED_FILE",
};
const ALLOCATED_ASSETS_REQUEST = {
  GET_ALLOCATED_ASSETS_REQUEST: "GET_ALLOCATED_ASSETS_REQUEST",
  GET_ALLOCATED_ASSETS_SUCCESS: "GET_ALLOCATED_ASSETS_SUCCESS",
  GET_ALLOCATED_ASSETS_FAILURE: "GET_ALLOCATED_ASSETS_FAILURE",
  ADD_ALLOCATED_ASSETS_REQUEST: "ADD_ALLOCATED_ASSETS_REQUEST",
  ADD_ALLOCATED_ASSETS_SUCCESS: "ADD_ALLOCATED_ASSETS_SUCCESS",
  ADD_ALLOCATED_ASSETS_FAILURE: "ADD_ALLOCATED_ASSETS_FAILURE",
  REMOVE_ALLOCATED_ASSETS_REQUEST: "REMOVE_ALLOCATED_ASSETS_REQUEST",
  REMOVE_ALLOCATED_ASSETS_SUCCESS: "REMOVE_ALLOCATED_ASSETS_SUCCESS",
  REMOVE_ALLOCATED_ASSETS_FAILURE: "REMOVE_ALLOCATED_ASSETS_FAILURE",
  EDIT_ALLOCATED_ASSETS_REQUEST: "EDIT_ALLOCATED_ASSETS_REQUEST",
  EDIT_ALLOCATED_ASSETS_SUCCESS: "EDIT_ALLOCATED_ASSETS_SUCCESS",
  EDIT_ALLOCATED_ASSETS_FAILURE: "EDIT_ALLOCATED_ASSETS_FAILURE",
};
const CLIENTS = {
  GET_CLIENT_REQUEST: "GET_CLIENT_REQUEST",
  GET_CLIENT_SUCCESS: "GET_CLIENT_SUCCESS",
  GET_CLIENT_FAILURE: "GET_CLIENT_FAILURE",
  ADD_CLIENT_REQUEST: "ADD_CLIENT_REQUEST",
  ADD_CLIENT_SUCCESS: "ADD_CLIENT_SUCCESS",
  ADD_CLIENT_FAILURE: "ADD_CLIENT_FAILURE",
  EDIT_CLIENT_REQUEST: "EDIT_CLIENT_REQUEST",
  EDIT_CLIENT_SUCCESS: "EDIT_CLIENT_SUCCESS",
  EDIT_CLIENT_FAILURE: "EDIT_CLIENT_FAILURE",
  REMOVE_CLIENT_REQUEST: "REMOVE_CLIENT_REQUEST",
  REMOVE_CLIENT_SUCCESS: "REMOVE_CLIENT_SUCCESS",
  REMOVE_CLIENT_FAILURE: "REMOVE_CLIENT_FAILURE",
};

const BD_PROJECT_DATA_REQUEST = {
  GET_COUNTRIE_REQUEST: "GET_COUNTRIE_REQUEST",
  GET_COUNTRIE_SUCCESS: "GET_COUNTRIE_SUCCESS",
  GET_COUNTRIE_FAILURE: "GET_COUNTRIE_FAILURE",

  GET_WARM_LEADS_REQUEST: "GET_WARM_LEADS_REQUEST",
  GET_WARM_LEADS_SUCCESS: "GET_WARM_LEADS_SUCCESS",
  GET_WARM_LEADS_FAILURE: "GET_WARM_LEADS_FAILURE",

  GET_LEADS_PER_PLATFORM_REQUEST: "GET_LEADS_PER_PLATFORM_REQUEST",
  GET_LEADS_PER_PLATFORM_SUCCESS: "GET_LEADS_PER_PLATFORM_SUCCESS",
  GET_LEADS_PER_PLATFORM_FAILURE: "GET_LEADS_PER_PLATFORM_FAILURE",

  GET_BUSINESS_PER_AGENT_REQUEST: "GET_BUSINESS_PER_AGENT_REQUEST",
  GET_BUSINESS_PER_AGENT_SUCCESS: "GET_BUSINESS_PER_AGENT_SUCCESS",
  GET_BUSINESS_PER_AGENT_FAILURE: "GET_BUSINESS_PER_AGENT_FAILURE",

  LEADS_GENERATED_PER_AGENT_REQUEST: "LEADS_GENERATED_PER_AGENT_REQUEST",
  LEADS_GENERATED_PER_AGENT_SUCCESS: "LEADS_GENERATED_PER_AGENT_SUCCESS",
  LEADS_GENERATED_PER_AGENT_FAILURE: "LEADS_GENERATED_PER_AGENT_FAILURE",

  CONVERSION_PER_AGENT_REQUEST: "CONVERSION_PER_AGENT_REQUEST",
  CONVERSION_PER_AGENT_SUCCESS: "CONVERSION_PER_AGENT_SUCCESS",
  CONVERSION_PER_AGENT_FAILURE: "CONVERSION_PER_AGENT_FAILURE",

  CONVERSION_TREND_REQUEST: "CONVERSION_TREND_REQUEST",
  CONVERSION_TREND_SUCCESS: "CONVERSION_TREND_SUCCESS",
  CONVERSION_TREND_FAILURE: "CONVERSION_TREND_FAILURE",

  QUARTERLY_DATA_REQUEST: "QUARTERLY_DATA_REQUEST",
  QUARTERLY_DATA_SUCCESS: "QUARTERLY_DATA_SUCCESS",
  QUARTERLY_DATA_FAILURE: "QUARTERLY_DATA_FAILURE",

  GET_WARM_LEADS_LIST_REQUEST: "GET_WARM_LEADS_LIST_REQUEST",
  GET_WARM_LEADS_LIST_SUCCESS: "GET_WARM_LEADS_LIST_SUCCESS",
  GET_WARM_LEADS_LIST_FAILURE: "GET_WARM_LEADS_LIST_FAILURE",

  GET_STATE_REQUEST: "GET_STATE_REQUEST",
  GET_STATE_SUCCESS: "GET_STATE_SUCCESS",
  GET_STATE_FAILURE: "GET_STATE_FAILURE",

  GET_CITY_REQUEST: "GET_CITY_REQUEST",
  GET_CITY_SUCCESS: "GET_CITY_SUCCESS",
  GET_CITY_FAILURE: "GET_CITY_FAILURE",

  GET_PROJECT_CATEGORY_REQUEST: "GET_PROJECT_CATEGORY_REQUEST",
  GET_PROJECT_CATEGORY_SUCCESS: "GET_PROJECT_CATEGORY_SUCCESS",
  GET_PROJECT_CATEGORY_FAILURE: "GET_PROJECT_CATEGORY_FAILURE",

  GET_KEYWORDS_REQUEST: "GET_KEYWORDS_REQUEST",
  GET_KEYWORDS_SUCCESS: "GET_KEYWORDS_SUCCESS",
  GET_KEYWORDS_FAILURE: "GET_KEYWORDS_FAILURE",

  GET_TECH_KEYWORDS_REQUEST: "GET_TECH_KEYWORDS_REQUEST",
  GET_TECH_KEYWORDS_SUCCESS: "GET_TECH_KEYWORDS_SUCCESS",
  GET_TECH_KEYWORDS_FAILURE: "GET_TECH_KEYWORDS_FAILURE",

  GET_PROJECTS_DATA_REQUEST: "GET_PROJECTS_DATA_REQUEST",
  GET_PROJECTS_DATA_SUCCESS: "GET_PROJECTS_DATA_SUCCESS",
  GET_PROJECTS_DATA_FAILURE: "GET_PROJECTS_DATA_FAILURE",

  GET_PROJECT_DATA_REQUEST: "GET_PROJECT_DATA_REQUEST",
  GET_PROJECT_DATA_SUCCESS: "GET_PROJECT_DATA_SUCCESS",
  GET_PROJECT_DATA_FAILURE: "GET_PROJECT_DATA_FAILURE",
  CLEAR_PROJECT_DATA: "CLEAR_PROJECT_DATA",

  SAVE_PROJECT_DATA_REQUEST: "SAVE_PROJECT_DATA_REQUEST",
  SAVE_PROJECT_DATA_SUCCESS: "SAVE_PROJECT_DATA_SUCCESS",
  SAVE_PROJECT_DATA_FAILURE: "SAVE_PROJECT_DATA_FAILURE",

  DELETE_PROJECT_DATA_REQUEST: "DELETE_PROJECT_DATA_REQUEST",
  DELETE_PROJECT_DATA_SUCCESS: "DELETE_PROJECT_DATA_SUCCESS",
  DELETE_PROJECT_DATA_FAILURE: "DELETE_PROJECT_DATA_FAILURE",

  CHECK_PROJECT_EMAIL_REQUEST: "CHECK_PROJECT_EMAIL_REQUEST",
  CHECK_PROJECT_EMAIL_SUCCESS: "CHECK_PROJECT_EMAIL_SUCCESS",
  CHECK_PROJECT_EMAIL_FAILURE: "CHECK_PROJECT_EMAIL_FAILURE",

  CHECK_PROJECT_POST_URL_REQUEST: "CHECK_PROJECT_POST_URL_REQUEST",
  CHECK_PROJECT_POST_URL_SUCCESS: "CHECK_PROJECT_POST_URL_SUCCESS",
  CHECK_PROJECT_POST_URL_FAILURE: "CHECK_PROJECT_POST_URL_FAILURE",

  VERIFY_PROJECT_PHONE_REQUEST: "VERIFY_PROJECT_PHONE_REQUEST",
  VERIFY_PROJECT_PHONE_SUCCESS: "VERIFY_PROJECT_PHONE_SUCCESS",
  VERIFY_PROJECT_PHONE_FAILURE: "VERIFY_PROJECT_PHONE_FAILURE",

  SAVE_PROJECT_AGENT_ALLOCATION_REQUEST:
    "SAVE_PROJECT_AGENT_ALLOCATION_REQUEST",
  SAVE_PROJECT_AGENT_ALLOCATION_SUCCESS:
    "SAVE_PROJECT_AGENT_ALLOCATION_SUCCESS",
  SAVE_PROJECT_AGENT_ALLOCATION_FAILURE:
    "SAVE_PROJECT_AGENT_ALLOCATION_FAILURE",

  DELETE_PROJECT_AGENT_ALLOCATION_REQUEST:
    "DELETE_PROJECT_AGENT_ALLOCATION_REQUEST",
  DELETE_PROJECT_AGENT_ALLOCATION_SUCCESS:
    "DELETE_PROJECT_AGENT_ALLOCATION_SUCCESS",
  DELETE_PROJECT_AGENT_ALLOCATION_FAILURE:
    "DELETE_PROJECT_AGENT_ALLOCATION_FAILURE",

  GET_PROJECT_AGENT_ALLOCATION_REQUEST: "GET_PROJECT_AGENT_ALLOCATION_REQUEST",
  GET_PROJECT_AGENT_ALLOCATION_SUCCESS: "GET_PROJECT_AGENT_ALLOCATION_SUCCESS",
  GET_PROJECT_AGENT_ALLOCATION_FAILURE: "GET_PROJECT_AGENT_ALLOCATION_FAILURE",

  GET_PROJECT_AGENT_ALLOCATION_LIST_REQUEST:
    "GET_PROJECT_AGENT_ALLOCATION_LIST_REQUEST",
  GET_PROJECT_AGENT_ALLOCATION_LIST_SUCCESS:
    "GET_PROJECT_AGENT_ALLOCATION_LIST_SUCCESS",
  GET_PROJECT_AGENT_ALLOCATION_LIST_FAILURE:
    "GET_PROJECT_AGENT_ALLOCATION_LIST_FAILURE",
};
const PROJECT_TEMPLATES_REQUEST = {
  GET_TEMPLATE_BYID_REQUEST: "GET_TEMPLATE_BYID_REQUEST",
  GET_TEMPLATE_BYID_SUCCESS: "GET_TEMPLATE_BYID_SUCCESS",
  GET_TEMPLATE_BYID_FAILURE: "GET_TEMPLATE_BYID_FAILURE",
  GET_TEMPLATE_BOARD_REQUEST: "GET_TEMPLATE_BOARD_REQUEST",
  GET_TEMPLATE_BOARD_SUCCESS: "GET_TEMPLATE_BOARD_SUCCESS",
  GET_TEMPLATE_BOARD_FAILURE: "GET_TEMPLATE_BOARD_FAILURE",
};
const FINANCE_DASHBOARD_REQUEST = {
  GET_INCOME_EXPENSE_GRAPH_REQUEST: "GET_INCOME_EXPENSE_GRAPH_REQUEST",
  GET_INCOME_EXPENSE_GRAPH_SUCCESS: "GET_INCOME_EXPENSE_GRAPH_SUCCESS",
  GET_INCOME_EXPENSE_GRAPH_FAILURE: "GET_INCOME_EXPENSE_GRAPH_FAILURE",
  GET_EXPENSE_TYPE_WISE_ANALYSIS_REQUEST:
    "GET_EXPENSE_TYPE_WISE_ANALYSIS_REQUEST",
  GET_EXPENSE_TYPE_WISE_ANALYSIS_SUCCESS:
    "GET_EXPENSE_TYPE_WISE_ANALYSIS_SUCCESS",
  GET_EXPENSE_TYPE_WISE_ANALYSIS_FAILURE:
    "GET_EXPENSE_TYPE_WISE_ANALYSIS_FAILURE",
  GET_PROJECT_BUDGET_LEAD_REQUEST: "GET_PROJECT_BUDGET_LEAD_REQUEST",
  GET_PROJECT_BUDGET_LEAD_SUCCESS: "GET_PROJECT_BUDGET_LEAD_SUCCESS",
  GET_PROJECT_BUDGET_LEAD_FAILURE: "GET_PROJECT_BUDGET_LEAD_FAILURE",
  GET_MONTHLY_EXPENSES_REQUEST: "GET_MONTHLY_EXPENSES_REQUEST",
  GET_MONTHLY_EXPENSES_SUCCESS: "GET_MONTHLY_EXPENSES_SUCCESS",
  GET_MONTHLY_EXPENSES_FAILURE: "GET_MONTHLY_EXPENSES_FAILURE",
  GET_YEARLY_INCOME_EXPENSE_REQUEST: "GET_YEARLY_INCOME_EXPENSE_REQUEST",
  GET_YEARLY_INCOME_EXPENSE_SUCCESS: "GET_YEARLY_INCOME_EXPENSE_SUCCESS",
  GET_YEARLY_INCOME_EXPENSE_FAILURE: "GET_YEARLY_INCOME_EXPENSE_FAILURE",
};
const DAILY_ATTENDANCE_REQUEST = {
  GET_DAILY_ATTENDANCE_REPORT_REQUEST: "GET_DAILY_ATTENDANCE_REPORT_REQUEST",
  GET_DAILY_ATTENDANCE_REPORT_SUCCESS: "GET_DAILY_ATTENDANCE_REPORT_SUCCESS",
  GET_DAILY_ATTENDANCE_REPORT_FAILURE: "GET_DAILY_ATTENDANCE_REPORT_FAILURE",
};
const ATTENDANCE_REQUEST = {
  GET_ATTENDANCE_REPORT_REQUEST: "GET_ATTENDANCE_REPORT_REQUEST",
  GET_ATTENDANCE_REPORT_SUCCESS: "GET_ATTENDANCE_REPORT_SUCCESS",
  GET_ATTENDANCE_REPORT_FAILURE: "GET_ATTENDANCE_REPORT_FAILURE",
};
const DEPARTMENTS = {
  GET_ALL_DEPARTMENTS_REQUEST: "GET_ALL_DEPARTMENTS_REQUEST",
  GET_ALL_DEPARTMENTS_SUCCESS: "GET_ALL_DEPARTMENTS_SUCCESS",
  GET_ALL_DEPARTMENTS_FAILURE: "GET_ALL_DEPARTMENTS_FAILURE",

  GET_DEPARTMENTS_SELECTLIST_REQUEST: "GET_DEPARTMENTS_SELECTLIST_REQUEST",
  GET_DEPARTMENTS_SELECTLIST_SUCCESS: "GET_DEPARTMENTS_SELECTLIST_SUCCESS",
  GET_DEPARTMENTS_SELECTLIST_FAILURE: "GET_DEPARTMENTS_SELECTLIST_FAILURE",

  ADD_DEPARTMENT_REQUEST: "ADD_DEPARTMENT_REQUEST",
  ADD_DEPARTMENT_SUCCESS: "ADD_DEPARTMENT_SUCCESS",
  ADD_DEPARTMENT_FAILURE: "ADD_DEPARTMENT_FAILURE",

  DELETE_DEPARTMENT_REQUEST: "DELETE_DEPARTMENT_REQUEST",
  DELETE_DEPARTMENT_SUCCESS: "DELETE_DEPARTMENT_SUCCESS",
  DELETE_DEPARTMENT_FAILURE: "DELETE_DEPARTMENT_FAILURE",

  EDIT_DEPARTMENT_REQUEST: "EDIT_DEPARTMENT_REQUEST",
  EDIT_DEPARTMENT_SUCCESS: "EDIT_DEPARTMENT_SUCCESS",
  EDIT_DEPARTMENT_FAILURE: "EDIT_DEPARTMENT_FAILURE",
};
const DEPARTMENT_TASK_CATEGORY = {
  GET_CATEGORIES_REQUEST: "GET_CATEGORIES_REQUEST",
  GET_CATEGORIES_SUCCESS: "GET_CATEGORIES_SUCCESS",
  GET_CATEGORIES_FAILURE: "GET_CATEGORIES_FAILURE",

  ADD_CATEGORY_REQUEST: "ADD_CATEGORY_REQUEST",
  ADD_CATEGORY_SUCCESS: "ADD_CATEGORY_SUCCESS",
  ADD_CATEGORY_FAILURE: "ADD_CATEGORY_FAILURE",

  EDIT_CATEGORY_REQUEST: "EDIT_CATEGORY_REQUEST",
  EDIT_CATEGORY_SUCCESS: "EDIT_CATEGORY_SUCCESS",
  EDIT_CATEGORY_FAILURE: "EDIT_CATEGORY_FAILURE",

  DELETE_CATEGORY_REQUEST: "DELETE_CATEGORY_REQUEST",
  DELETE_CATEGORY_SUCCESS: "DELETE_CATEGORY_SUCCESS",
  DELETE_CATEGORY_FAILURE: "DELETE_CATEGORY_FAILURE",

  GET_CATEGORIES_SELECTLIST_REQUEST: "GET_CATEGORIES_SELECTLIST_REQUEST",
  GET_CATEGORIES_SELECTLIST_SUCCESS: "GET_CATEGORIES_SELECTLIST_SUCCESS",
  GET_CATEGORIES_SELECTLIST_FAILURE: "GET_CATEGORIES_SELECTLIST_FAILURE",
};
const USER_LIST_REQUEST = {
  GET_USER_REQUEST: "GET_USER_REQUEST",
  GET_USER_SUCCESS: "GET_USER_SUCCESS",
  GET_USER_FAILURE: "GET_USER_FAILURE",
};
const TEAMS_REQUEST = {
  GET_ALL_TEAMS_REQUEST: "GET_ALL_TEAMS_REQUEST",
  GET_ALL_TEAMS_SUCCESS: "GET_ALL_TEAMS_SUCCESS",
  GET_ALL_TEAMS_FAILURE: "GET_ALL_TEAMS_FAILURE",
  ADD_NEW_TEAM_REQUEST: "ADD_NEW_TEAM_REQUEST",
  ADD_NEW_TEAM_SUCCESS: "ADD_NEW_TEAM_SUCCESS",
  ADD_NEW_TEAM_FAILURE: "ADD_NEW_TEAM_FAILURE",
  DELETE_TEAM_REQUEST: "DELETE_TEAM_REQUEST",
  DELETE_TEAM_SUCCESS: "DELETE_TEAM_SUCCESS",
  DELETE_TEAM_FAILURE: "DELETE_TEAM_FAILURE",
  EDIT_TEAM_REQUEST: "EDIT_TEAM_REQUEST",
  EDIT_TEAM_SUCCESS: "EDIT_TEAM_SUCCESS",
  EDIT_TEAM_FAILURE: "EDIT_TEAM_FAILURE",
};
const SUGGESTION_REQUEST = {
  GET_SUGGESTIONS_REQUEST: "GET_SUGGESTIONS_REQUEST",
  GET_SUGGESTIONS_SUCCESS: "GET_SUGGESTIONS_SUCCESS",
  GET_SUGGESTIONS_FAILURE: "GET_SUGGESTIONS_FAILURE",
  ADD_SUGGESTIONS_REQUEST: "ADD_SUGGESTIONS_REQUEST",
  ADD_SUGGESTIONS_SUCCESS: "ADD_SUGGESTIONS_SUCCESS",
  ADD_SUGGESTIONS_FAILURE: "ADD_SUGGESTIONS_FAILURE",
  EDIT_SUGGESTION_STATUS: "EDIT_SUGGESTION_STATUS",
};
const HOLIDAYS = {
  GET_ALL_HOLIDAYS_REQUEST: "GET_ALL_HOLIDAYS_REQUEST",
  GET_ALL_HOLIDAYS_SUCCESS: "GET_ALL_HOLIDAYS_SUCCESS",
  GET_ALL_HOLIDAYS_FAILURE: "GET_ALL_HOLIDAYS_FAILURE",
};
const USER_ROLES = {
  GET_ALL_USER_ROLES_REQUEST: "GET_ALL_USER_ROLES_REQUEST",
  GET_ALL_USER_ROLES_SUCCESS: "GET_ALL_USER_ROLES_SUCCESS",
  GET_ALL_USER_ROLES_FAILURE: "GET_ALL_USER_ROLES_FAILURE",
  ADD_NEW_USER_ROLE_REQUEST: "ADD_NEW_USER_ROLE_REQUEST",
  ADD_NEW_USER_ROLE_SUCCESS: "ADD_NEW_USER_ROLE_SUCCESS",
  ADD_NEW_USER_ROLE_FAILURE: "ADD_NEW_USER_ROLE_FAILURE",
  EDIT_USER_ROLE_REQUEST: "EDIT_USER_ROLE_REQUEST",
  EDIT_USER_ROLE_SUCCESS: "EDIT_USER_ROLE_SUCCESS",
  EDIT_USER_ROLE_FAILURE: "EDIT_USER_ROLE_FAILURE",
  DELETE_USER_ROLE_REQUEST: "DELETE_USER_ROLE_REQUEST",
  DELETE_USER_ROLE_SUCCESS: "DELETE_USER_ROLE_SUCCESS",
  DELETE_USER_ROLE_FAILURE: "DELETE_USER_ROLE_FAILURE",
};
const PROJECTSETTINGS = {
  GET_PROJECT_SETTINGS_REQUEST: "GET_PROJECT_SETTINGS_REQUEST",
  GET_PROJECT_SETTINGS_SUCCESS: "GET_PROJECT_SETTINGS_SUCCESS",
  GET_PROJECT_SETTINGS_FAILURE: "GET_PROJECT_SETTINGS_FAILURE",
  ADD_PROJECT_SETTINGS_REQUEST: "ADD_PROJECT_SETTINGS_REQUEST",
  ADD_PROJECT_SETTINGS_SUCCESS: "ADD_PROJECT_SETTINGS_SUCCESS",
  ADD_PROJECT_SETTINGS_FAILURE: "ADD_PROJECT_SETTINGS_FAILURE",
  EDIT_PROJECT_SETTINGS_REQUEST: "EDIT_PROJECT_SETTINGS_REQUEST",
  EDIT_PROJECT_SETTINGS_SUCCESS: "EDIT_PROJECT_SETTINGS_SUCCESS",
  EDIT_PROJECT_SETTINGS_FAILURE: "EDIT_PROJECT_SETTINGS_FAILURE",
  DELETE_PROJECT_SETTINGS_REQUEST: "DELETE_PROJECT_SETTINGS_REQUEST",
  DELETE_PROJECT_SETTINGS_SUCCESS: "DELETE_PROJECT_SETTINGS_SUCCESS",
  DELETE_PROJECT_SETTINGS_FAILURE: "DELETE_PROJECT_SETTINGS_FAILURE",
  GET_PROJECT_CATEGORIES_REQUEST: "GET_PROJECT_CATEGORIES_REQUEST",
  GET_PROJECT_CATEGORIES_SUCCESS: "GET_PROJECT_CATEGORIES_SUCCESS",
  GET_PROJECT_CATEGORIES_FAILURE: "GET_PROJECT_CATEGORIES_FAILURE",
  ADD_PROJECT_CATEGORIES_REQUEST: "ADD_PROJECT_CATEGORIES_REQUEST",
  ADD_PROJECT_CATEGORIES_SUCCESS: "ADD_PROJECT_CATEGORIES_SUCCESS",
  ADD_PROJECT_CATEGORIES_FAILURE: "ADD_PROJECT_CATEGORIES_FAILURE",
  EDIT_PROJECT_CATEGORIES_REQUEST: "EDIT_PROJECT_CATEGORIES_REQUEST",
  EDIT_PROJECT_CATEGORIES_SUCCESS: "EDIT_PROJECT_CATEGORIES_SUCCESS",
  EDIT_PROJECT_CATEGORIES_FAILURE: "EDIT_PROJECT_CATEGORIES_FAILURE",
  DELETE_PROJECT_CATEGORIES_REQUEST: "DELETE_PROJECT_CATEGORIES_REQUEST",
  DELETE_PROJECT_CATEGORIES_SUCCESS: "DELETE_PROJECT_CATEGORIES_SUCCESS",
  DELETE_PROJECT_CATEGORIES_FAILURE: "DELETE_PROJECT_CATEGORIES_FAILURE",
};
const PROJECTCATEGORY = {
  GET_PROJECT_CATEGORY_REQUEST: "GET_PROJECT_CATEGORY_REQUEST",
  GET_PROJECT_CATEGORY_SUCCESS: "GET_PROJECT_CATEGORY_SUCCESS",
  GET_PROJECT_CATEGORY_FAILURE: "GET_PROJECT_CATEGORY_FAILURE",
};
const PROJECTINFO = {
  GET_PROJECT_INFO_REQUEST: "GET_PROJECT_INFO_REQUEST",
  GET_PROJECT_INFO_SUCCESS: "GET_PROJECT_INFO_SUCCESS",
  GET_PROJECT_INFO_FAILURE: "GET_PROJECT_INFO_FAILURE",
};

const ATTENDANCE = {
  MARK_ATTENDANCE_REQUEST: "MARK_ATTENDANCE_REQUEST",
  MARK_ATTENDANCE_SUCCESS: "MARK_ATTENDANCE_SUCCESS",
  MARK_ATTENDANCE_FAILURE: "MARK_ATTENDANCE_FAILURE",

  CHECKOUT_REQUEST: "CHECKOUT_REQUEST",
  CHECKOUT_SUCCESS: "CHECKOUT_SUCCESS",
  CHECKOUT_FAILURE: "CHECKOUT_FAILURE",

  LEAVE_REQUEST_REQUEST: "LEAVE_REQUEST_REQUEST",
  LEAVE_REQUEST_SUCCESS: "LEAVE_REQUEST_SUCCESS",
  LEAVE_REQUEST_FAILURE: "LEAVE_REQUEST_FAILURE",

  LEAVE_APPROVAL_REQUEST: "LEAVE_APPROVAL_REQUEST",
  LEAVE_APPROVAL_SUCCESS: "LEAVE_APPROVAL_SUCCESS",
  LEAVE_APPROVAL_FAILURE: "LEAVE_APPROVAL_FAILURE",

  ATTENDANCE_SUMMARY_REQUEST: "ATTENDANCE_SUMMARY_REQUEST",
  ATTENDANCE_SUMMARY_SUCCESS: "ATTENDANCE_SUMMARY_SUCCESS",
  ATTENDANCE_SUMMARY_FAILURE: "ATTENDANCE_SUMMARY_FAILURE",

  TODAY_ATTENDANCE_SUMMARY_REQUEST: "TODAY_ATTENDANCE_SUMMARY_REQUEST",
  TODAY_ATTENDANCE_SUMMARY_SUCCESS: "TODAY_ATTENDANCE_SUMMARY_SUCCESS",
  TODAY_ATTENDANCE_SUMMARY_FAILURE: "TODAY_ATTENDANCE_SUMMARY_FAILURE",

  ATTENDANCE_REPORT_REQUEST: "ATTENDANCE_REPORT_REQUEST",
  ATTENDANCE_REPORT_SUCCESS: "ATTENDANCE_REPORT_SUCCESS",
  ATTENDANCE_REPORT_FAILURE: "ATTENDANCE_REPORT_FAILURE",

  LEAVE_REQUEST_LIST_REQUEST: "LEAVE_REQUEST_LIST_REQUEST",
  LEAVE_REQUEST_LIST_SUCCESS: "LEAVE_REQUEST_LIST_SUCCESS",
  LEAVE_REQUEST_LIST_FAILURE: "LEAVE_REQUEST_LIST_FAILURE",

  DAILY_ATTENDANCE_REQUEST: "DAILY_ATTENDANCE_REQUEST",
  DAILY_ATTENDANCE_SUCCESS: "DAILY_ATTENDANCE_SUCCESS",
  DAILY_ATTENDANCE_FAILURE: "DAILY_ATTENDANCE_FAILURE",

  NEXT_DAILY_ATTENDANCE_REQUEST: "NEXT_DAILY_ATTENDANCE_REQUEST",
  NEXT_DAILY_ATTENDANCE_SUCCESS: "NEXT_DAILY_ATTENDANCE_SUCCESS",
  NEXT_DAILY_ATTENDANCE_FAILURE: "NEXT_DAILY_ATTENDANCE_FAILURE",

  FILTER_DAILY_ATTENDANCE_REQUEST: "FILTER_DAILY_ATTENDANCE_REQUEST",
  FILTER_DAILY_ATTENDANCE_SUCCESS: "FILTER_DAILY_ATTENDANCE_SUCCESS",
  FILTER_DAILY_ATTENDANCE_FAILURE: "FILTER_DAILY_ATTENDANCE_FAILURE",

  EMPLOYEE_CHECK_IN_OR_OUT_REQUEST: "EMPLOYEE_CHECK_IN_OR_OUT_REQUEST",
  EMPLOYEE_CHECK_IN_OR_OUT_SUCCESS: "EMPLOYEE_CHECK_IN_OR_OUT_SUCCESS",
  EMPLOYEE_CHECK_IN_OR_OUT_FAILURE: "EMPLOYEE_CHECK_IN_OR_OUT_FAILURE",
  LATE_CHECK_IN_REQUEST: "LATE_CHECK_IN_REQUEST",
  LATE_CHECK_IN_SUCCESS: "LATE_CHECK_IN_SUCCESS",
  LATE_CHECK_IN_FAILURE: "LATE_CHECK_IN_FAILURE",
  GET_EMPLOYEE_TODAY_ATTENDANCE_REQUEST:
    "GET_EMPLOYEE_TODAY_ATTENDANCE_REQUEST",
  GET_EMPLOYEE_TODAY_ATTENDANCE_SUCCESS:
    "GET_EMPLOYEE_TODAY_ATTENDANCE_SUCCESS",
  GET_EMPLOYEE_TODAY_ATTENDANCE_FAILURE:
    "GET_EMPLOYEE_TODAY_ATTENDANCE_FAILURE",

  GET_LEAVE_REQUEST: "GET_LEAVE_REQUEST",
  GET_LEAVE_SUCCESS: "GET_LEAVE_SUCCESS",
  GET_LEAVE_FAILURE: "GET_LEAVE_FAILURE",

  GET_ATTENDANCE_BY_ADMIN_REPORT_REQUEST:
    "GET_ATTENDANCE_BY_ADMIN_REPORT_REQUEST",
  GET_ATTENDANCE_BY_ADMIN_REPORT_SUCCESS:
    "GET_ATTENDANCE_BY_ADMIN_REPORT_SUCCESS",
  GET_ATTENDANCE_BY_ADMIN_REPORT_FAILURE:
    "GET_ATTENDANCE_BY_ADMIN_REPORT_FAILURE",

  GET_SHORT_LEAVE_REQUEST: "GET_SHORT_LEAVE_REQUEST",
  GET_SHORT_LEAVE_SUCCESS: "GET_SHORT_LEAVE_SUCCESS",
  GET_SHORT_LEAVE_FAILURE: "GET_SHORT_LEAVE_FAILURE",
  APPROVE_LEAVE_REQUEST: "APPROVE_LEAVE_REQUEST",
  APPROVE_LEAVE_SUCCESS: "APPROVE_LEAVE_SUCCESS",
  APPROVE_LEAVE_FAILURE: "APPROVE_LEAVE_FAILURE",
  GET_EMPLOYEES_ATTENDANCE_REQUEST: "GET_EMPLOYEES_ATTENDANCE_REQUEST",
  GET_EMPLOYEES_ATTENDANCE_SUCCESS: "GET_EMPLOYEES_ATTENDANCE_SUCCESS",
  GET_EMPLOYEES_ATTENDANCE_FAILURE: "GET_EMPLOYEES_ATTENDANCE_FAILURE",

  SHORT_BREAK_REQUEST: "SHORT_BREAK_REQUEST",
  SHORT_BREAK_SUCCESS: "SHORT_BREAK_SUCCESS",
  SHORT_BREAK_FAILURE: "SHORT_BREAK_FAILURE",

  END_BREAK_REQUEST: "END_BREAK_REQUEST",
  END_BREAK_SUCCESS: "END_BREAK_SUCCESS",
  END_BREAK_FAILURE: "END_BREAK_FAILURE",
  GET_BREAK_TYPES_REQUEST: "GET_BREAK_TYPES_REQUEST",
  GET_BREAK_TYPES_SUCCESS: "GET_BREAK_TYPES_SUCCESS",
  GET_BREAK_TYPES_FAILURE: "GET_BREAK_TYPES_FAILURE",
};

const TODO = {
  FILL_DATA_STORE_USERS: "FILL_DATA_STORE_USERS",
  POPULATE_USERS_TODOLISTS: "POPULATE_USERS_TODOLISTS",
  GET_TEAM_MEMBERS: "GET_TEAM_MEMBERS",
  SET_TEAM_MEMBER_ID: "SET_TEAM_MEMBER_ID",

  CLEAR_TODO_EMPLOYEES: "CLEAR_TODO_EMPLOYEES",

  GET_TODO_EMPLOYEES_REQUEST: "GET_TODO_EMPLOYEES_REQUEST",
  GET_TODO_EMPLOYEES_SUCCESS: "GET_TODO_EMPLOYEES_SUCCESS",
  GET_TODO_EMPLOYEES_FAILURE: "GET_TODO_EMPLOYEES_FAILURE",

  GET_TODO_REQUEST: "GET_TODO_REQUEST",
  GET_TODO_SUCCESS: "GET_TODO_SUCCESS",
  GET_TODO_FAILURE: "GET_TODO_FAILURE",

  GET_EMPLOYEES_REQUEST: "GET_EMPLOYEES_REQUEST",
  GET_EMPLOYEES_SUCCESS: "GET_EMPLOYEES_SUCCESS",
  GET_EMPLOYEES_FAILURE: "GET_EMPLOYEES_FAILURE",

  ADD_TODO_REQUEST: "ADD_TODO_REQUEST",
  ADD_TODO_SUCCESS: "ADD_TODO_SUCCESS",
  ADD_TODO_FAILURE: "ADD_TODO_FAILURE",
  EDIT_TODO_REQUEST: "EDIT_TODO_REQUEST",
  EDIT_TODO_SUCCESS: "EDIT_TODO_SUCCESS",
  EDIT_TODO_FAILURE: "EDIT_TODO_FAILURE",
  DELETE_TODO_REQUEST: "DELETE_TODO_REQUEST",
  DELETE_TODO_SUCCESS: "DELETE_TODO_SUCCESS",
  DELETE_TODO_FAILURE: "DELETE_TODO_FAILURE",
  GET_ALL_USER_TODO_REQUEST: "GET_ALL_USER_TODO_REQUEST",
  GET_ALL_USER_TODO_SUCCESS: "GET_ALL_USER_TODO_SUCCESS",
  GET_ALL_USER_TODO_FAILURE: "GET_ALL_USER_TODO_FAILURE",
  COMPLETE_TODO_REQUEST: "COMPLETE_TODO_REQUEST",
  COMPLETE_TODO_SUCCESS: "COMPLETE_TODO_SUCCESS",
  COMPLETE_TODO_FAILURE: "COMPLETE_TODO_FAILURE",

  POST_TODO_COMMENT_REQUEST: "POST_TODO_COMMENT_REQUEST",
  POST_TODO_COMMENT_SUCCESS: "POST_TODO_COMMENT_SUCCESS",
  POST_TODO_COMMENT_FAILURE: "POST_TODO_COMMENT_FAILURE",

  GET_TODO_COMMENT_REQUEST: "GET_TODO_COMMENT_REQUEST",
  GET_TODO_COMMENT_SUCCESS: "GET_TODO_COMMENT_SUCCESS",
  GET_TODO_COMMENT_FAILURE: "GET_TODO_COMMENT_FAILURE",

  DELETE_TODO_COMMENT_REQUEST: "DELETE_TODO_COMMENT_REQUEST",
  DELETE_TODO_COMMENT_SUCCESS: "DELETE_TODO_COMMENT_SUCCESS",
  DELETE_TODO_COMMENT_FAILURE: "DELETE_TODO_COMMENT_FAILURE",

  IS_MY_TODOS_TRUE: "IS_MY_TODOS_TRUE",
  IS_MY_TODOS_FALSE: "IS_MY_TODOS_FALSE",
  // POST_TODO_REPLY_REQUEST: "POST_TODO_REPLY_REQUEST",
  // POST_TODO_REPLY_SUCCESS: "POST_TODO_REPLY_SUCCESS",
  // POST_TODO_REPLY_FAILURE: "POST_TODO_REPLY_FAILURE",

  TODO_MESSAGES_RESET: "TODO_MESSAGES_RESET",
  TODO_SORTING: "TODO_SORTING",

  LOAD_WORK_PROGRESS_REQUEST: "LOAD_WORK_PROGRESS_REQUEST",
  LOAD_WORK_PROGRESS_SUCCESS: "LOAD_WORK_PROGRESS_SUCCESS",
  LOAD_WORK_PROGRESS_FAILURE: "LOAD_WORK_PROGRESS_FAILURE",

  ADD_TODO_FLAG_REQUEST: "ADD_TODO_FLAG_REQUEST",
  ADD_TODO_FLAG_SUCCESS: "ADD_TODO_FLAG_SUCCESS",
  ADD_TODO_FLAG_FAILURE: "ADD_TODO_FLAG_FAILURE",

  GET_TASK_CATEGORIES_REQUEST: "GET_TASK_CATEGORIES_REQUEST",
  GET_TASK_CATEGORIES_SUCCESS: "GET_TASK_CATEGORIES_SUCCESS",
  GET_TASK_CATEGORIES_FAILURE: "GET_TASK_CATEGORIES_FAILURE",

  ADD_TODO_LOG_TIME_REQUEST: "ADD_TODO_LOG_TIME_REQUEST",
  ADD_TODO_LOG_TIME_SUCCESS: "ADD_TODO_LOG_TIME_SUCCESS",
  ADD_TODO_LOG_TIME_FAILURE: "ADD_TODO_LOG_TIME_FAILURE",

  GET_LOGGED_HOUR_GRAPH_DATA_REQUEST: "GET_LOGGED_HOUR_GRAPH_DATA_REQUEST",
  GET_LOGGED_HOUR_GRAPH_DATA_SUCCESS: "GET_LOGGED_HOUR_GRAPH_DATA_SUCCESS",
  GET_LOGGED_HOUR_GRAPH_DATA_FAILURE: "GET_LOGGED_HOUR_GRAPH_DATA_FAILURE",

  GET_ALL_HOME_USER_TODO_REQUEST: "GET_ALL_HOME_USER_TODO_REQUEST",
  GET_ALL_HOME_USER_TODO_SUCCESS: "GET_ALL_HOME_USER_TODO_SUCCESS",
  GET_ALL_HOME_USER_TODO_FAILURE: "GET_ALL_HOME_USER_TODO_FAILURE",

  GET_TASK_HOUR_COMPARISON_BY_EMP_REQUEST:
    "GET_TASK_HOUR_COMPARISON_BY_EMP_REQUEST",
  GET_TASK_HOUR_COMPARISON_BY_EMP_SUCCESS:
    "GET_TASK_HOUR_COMPARISON_BY_EMP_SUCCESS",
  GET_TASK_HOUR_COMPARISON_BY_EMP_FAILURE:
    "GET_TASK_HOUR_COMPARISON_BY_EMP_FAILURE",

  GET_EMP_RANKING_ON_LOGGED_HOURS_REQUEST:
    "GET_EMP_RANKING_ON_LOGGED_HOURS_REQUEST",
  GET_EMP_RANKING_ON_LOGGED_HOURS_SUCCESS:
    "GET_EMP_RANKING_ON_LOGGED_HOURS_SUCCESS",
  GET_EMP_RANKING_ON_LOGGED_HOURS_FAILURE:
    "GET_EMP_RANKING_ON_LOGGED_HOURS_FAILURE",

  GET_EMP_TASKS_GRAPH_REQUEST: "GET_EMP_TASKS_GRAPH_REQUEST",
  GET_EMP_TASKS_GRAPH_SUCCESS: "GET_EMP_TASKS_GRAPH_SUCCESS",
  GET_EMP_TASKS_GRAPH_FAILURE: "GET_EMP_TASKS_GRAPH_FAILURE",

  GET_EMP_TODO_TASK_LIST_REQUEST: "GET_EMP_TODO_TASK_LIST_REQUEST",
  GET_EMP_TODO_TASK_LIST_SUCCESS: "GET_EMP_TODO_TASK_LIST_SUCCESS",
  GET_EMP_TODO_TASK_LIST_FAILURE: "GET_EMP_TODO_TASK_LIST_FAILURE",

  GET_USER_TODOS_REQUEST: "GET_USER_TODOS_REQUEST",
  GET_USER_TODOS_SUCCESS: "GET_USER_TODOS_SUCCESS",
  GET_USER_TODOS_FAILURE: "GET_USER_TODOS_FAILURE",
};
const TODO_LIST = {
  GET_ALL_USER_TODO_REQUEST: "GET_ALL_USER_TODO_REQUEST",
  GET_ALL_USER_TODO_SUCCESS: "GET_ALL_USER_TODO_SUCCESS",
  GET_ALL_USER_TODO_FAILURE: "GET_ALL_USER_TODO_FAILURE",

  CREATE_TODO_LIST_REQUEST: "CREATE_TODO_LIST_REQUEST",
  CREATE_TODO_LIST_SUCCESS: "CREATE_TODO_LIST_SUCCESS",
  CREATE_TODO_LIST_FAILURE: "CREATE_TODO_LIST_FAILURE",
};

const FEEDBACK_REQUEST = {
  GET_TEMPLATES_LISTING_REQUEST: "GET_TEMPLATES_LISTING_REQUEST",
  GET_TEMPLATES_LISTING_SUCCESS: "GET_TEMPLATES_LISTING_SUCCESS",
  GET_TEMPLATES_LISTING_FAILURE: "GET_TEMPLATES_LISTING_FAILURE",

  ADD_TEMPLATE_REQUEST: "ADD_TEMPLATE_REQUEST",
  ADD_TEMPLATE_SUCCESS: "ADD_TEMPLATE_SUCCESS",
  ADD_TEMPLATE_FAILURE: "ADD_TEMPLATE_FAILURE",

  DELETE_TEMPLATE_REQUEST: "DELETE_TEMPLATE_REQUEST",
  DELETE_TEMPLATE_SUCCESS: "DELETE_TEMPLATE_SUCCESS",
  DELETE_TEMPLATE_FAILURE: "DELETE_TEMPLATE_FAILURE",
  RESET_DELETE_TEMPLATE: "RESET_DELETE_TEMPLATE",

  ADD_QUESTION_REQUEST: "ADD_QUESTION_REQUEST",
  ADD_QUESTION_SUCCESS: "ADD_QUESTION_SUCCESS",
  ADD_QUESTION_FAILURE: "ADD_QUESTION_FAILURE",

  GET_QUESTION_LISTING_REQUEST: "GET_QUESTION_LISTING_REQUEST",
  GET_QUESTION_LISTING_SUCCESS: "GET_QUESTION_LISTING_SUCCESS",
  GET_QUESTION_LISTING_FAILURE: "GET_QUESTION_LISTING_FAILURE",

  DELETE_QUESTION_REQUEST: "DELETE_QUESTION_REQUEST",
  DELETE_QUESTION_SUCCESS: "DELETE_QUESTION_SUCCESS",
  DELETE_QUESTION_FAILURE: "DELETE_QUESTION_FAILURE",
  RESET_DELETE_QUESTION: "RESET_DELETE_QUESTION",

  GET_FEEDBACK_REVIEWS_LISTING_REQUEST: "GET_FEEDBACK_REVIEWS_LISTING_REQUEST",
  GET_FEEDBACK_REVIEWS_LISTING_SUCCESS: "GET_FEEDBACK_REVIEWS_LISTING_SUCCESS",
  GET_FEEDBACK_REVIEWS_LISTING_FAILURE: "GET_FEEDBACK_REVIEWS_LISTING_FAILURE",

  GET_GIVE_FEEDBACK_REQUEST: "GET_GIVE_FEEDBACK_REQUEST",
  GET_GIVE_FEEDBACK_SUCCESS: "GET_GIVE_FEEDBACK_SUCCESS",
  GET_GIVE_FEEDBACK_FAILURE: "GET_GIVE_FEEDBACK_FAILURE",

  ADD_EVALUATION_REQUEST: "ADD_EVALUATION_REQUEST",
  ADD_EVALUATION_SUCCESS: "ADD_EVALUATION_SUCCESS",
  ADD_EVALUATION_FAILURE: "ADD_EVALUATION_FAILURE",

  ADD_ANSWERS_REQUEST: "ADD_ANSWERS_REQUEST",
  ADD_ANSWERS_SUCCESS: "ADD_ANSWERS_SUCCESS",
  ADD_ANSWERS_FAILURE: "ADD_ANSWERS_FAILURE",

  GET_EVALUATION_LISTING_REQUEST: "GET_EVALUATION_LISTING_REQUEST",
  GET_EVALUATION_LISTING_SUCCESS: "GET_EVALUATION_LISTING_SUCCESS",
  GET_EVALUATION_LISTING_FAILURE: "GET_EVALUATION_LISTING_FAILURE",

  GET_ANSWERS_BYEVALUATION_ID_REQUEST: "GET_ANSWERS_BYEVALUATION_ID_REQUEST",
  GET_ANSWERS_BYEVALUATION_ID_SUCCESS: "GET_ANSWERS_BYEVALUATION_ID_SUCCESS",
  GET_ANSWERS_BYEVALUATION_ID_FAILURE: "GET_ANSWERS_BYEVALUATION_ID_FAILURE",
  RESET_GET_ANSWERS_BY_EVALUATION_ID: "RESET_GET_ANSWERS_BY_EVALUATION_ID",

  COMPLETE_EVALUATION_REQUEST: "COMPLETE_EVALUATION_REQUEST",
  COMPLETE_EVALUATION_SUCCESS: "COMPLETE_EVALUATION_SUCCESS",
  COMPLETE_EVALUATION_FAILURE: "COMPLETE_EVALUATION_FAILURE",

  GET_FILTERED_EVALUATION_REQUEST: "GET_FILTERED_EVALUATION_REQUEST",
  GET_FILTERED_EVALUATION_SUCCESS: "GET_FILTERED_EVALUATION_SUCCESS",
  GET_FILTERED_EVALUATION_FAILURE: "GET_FILTERED_EVALUATION_FAILURE",
};

const FILE = {
  GET_FOLDER_REQUEST: "GET_FOLDER_REQUEST",
  GET_FOLDER_SUCCESS: "GET_FOLDER_SUCCESS",
  GET_FOLDER_FAILURE: "GET_FOLDER_FAILURE",

  ADD_FOLDER_REQUEST: "ADD_FOLDER_REQUEST",
  ADD_FOLDER_SUCCESS: "ADD_FOLDER_SUCCESS",
  ADD_FOLDER_FAILURE: "ADD_FOLDER_FAILURE",

  GET_RECENT_FOLDER_REQUEST: "GET_RECENT_FOLDER_REQUEST",
  GET_RECENT_FOLDER_SUCCESS: "GET_RECENT_FOLDER_SUCCESS",
  GET_RECENT_FOLDER_FAILURE: "GET_RECENT_FOLDER_FAILURE",

  GET_FAVORITE_FOLDER_REQUEST: "GET_FAVORITE_FOLDER_REQUEST",
  GET_FAVORITE_FOLDER_SUCCESS: "GET_FAVORITE_FOLDER_SUCCESS",
  GET_FAVORITE_FOLDER_FAILURE: "GET_FAVORITE_FOLDER_FAILURE",

  DELETE_FOLDER_REQUEST: "DELETE_FOLDER_REQUEST",
  DELETE_FOLDER_SUCCESS: "DELETE_FOLDER_SUCCESS",
  DELETE_FOLDER_FAILURE: "DELETE_FOLDER_FAILURE",

  GET_DELETED_FOLDER_REQUEST: "GET_DELETED_FOLDER_REQUEST",
  GET_DELETED_FOLDER_SUCCESS: "GET_DELETED_FOLDER_SUCCESS",
  GET_DELETED_FOLDER_FAILURE: "GET_DELETED_FOLDER_FAILURE",

  ADD_REMOVE_FAVORITE_FOLDER_REQUEST: "ADD_REMOVE_FAVORITE_FOLDER_REQUEST",
  ADD_REMOVE_FAVORITE_FOLDER_SUCCESS: "ADD_REMOVE_FAVORITE_FOLDER_SUCCESS",
  ADD_REMOVE_FAVORITE_FOLDER_FAILURE: "ADD_REMOVE_FAVORITE_FOLDER_FAILURE",

  GET_FILE_REQUEST: "GET_FILE_REQUEST",
  GET_FILE_SUCCESS: "GET_FILE_SUCCESS",
  GET_FILE_FAILURE: "GET_FILE_FAILURE",

  ADD_FILE_REQUEST: "ADD_FILE_REQUEST",
  ADD_FILE_SUCCESS: "ADD_FILE_SUCCESS",
  ADD_FILE_FAILURE: "ADD_FILE_FAILURE",

  GET_FAVORITE_FILE_REQUEST: "GET_FAVORITE_FILE_REQUEST",
  GET_FAVORITE_FILE_SUCCESS: "GET_FAVORITE_FILE_SUCCESS",
  GET_FAVORITE_FILE_FAILURE: "GET_FAVORITE_FILE_FAILURE",

  GET_RECENT_FILE_REQUEST: "GET_RECENT_FILE_REQUEST",
  GET_RECENT_FILE_SUCCESS: "GET_RECENT_FILE_SUCCESS",
  GET_RECENT_FILE_FAILURE: "GET_RECENT_FILE_FAILURE",

  ADD_REMOVE_FAVORITE_FILE_REQUEST: "ADD_REMOVE_FAVORITE_FILE_REQUEST",
  ADD_REMOVE_FAVORITE_FILE_SUCCESS: "ADD_REMOVE_FAVORITE_FILE_SUCCESS",
  ADD_REMOVE_FAVORITE_FILE_FAILURE: "ADD_REMOVE_FAVORITE_FILE_FAILURE",

  DELETE_FILE_REQUEST: "DELETE_FILE_REQUEST",
  DELETE_FILE_SUCCESS: "DELETE_FILE_SUCCESS",
  DELETE_FILE_FAILURE: "DELETE_FILE_FAILURE",

  GET_DELETED_FILE_REQUEST: "GET_DELETED_FILE_REQUEST",
  GET_DELETED_FILE_SUCCESS: "GET_DELETED_FILE_SUCCESS",
  GET_DELETED_FILE_FAILURE: "GET_DELETED_FILE_FAILURE",

  SEARCH_FILE_REQUEST: "SEARCH_FILE_REQUEST",
  SEARCH_FILE_SUCCESS: "SEARCH_FILE_SUCCESS",
  SEARCH_FILE_FAILURE: "SEARCH_FILE_FAILURE",

  SEARCH_DATE_FILE_REQUEST: "SEARCH_DATE_FILE_REQUEST",
  SEARCH_DATE_FILE_SUCCESS: "SEARCH_DATE_FILE_SUCCESS",
  SEARCH_DATE_FILE_FAILURE: "SEARCH_DATE_FILE_FAILURE",
};

const WORKLOAD_REQUEST = {
  GET_SIDBAR_REQUEST: "GET_SIDBAR_REQUEST",
  GET_SIDBAR_SUCCESS: "GET_SIDBAR_SUCCESS",
  GET_SIDBAR_FAILURE: "GET_SIDBAR_FAILURE",

  GET_EMPWORKLOAD_REQUEST: "GET_EMPWORKLOAD_REQUEST",
  GET_EMPWORKLOAD_SUCCESS: "GET_EMPWORKLOAD_SUCCESS",
  GET_EMPWORKLOAD_FAILURE: "GET_EMPWORKLOAD_FAILURE",

  GET_EMPLOYEE_LIST_REQUEST: "GET_EMPLOYEE_LIST_REQUEST",
  GET_EMPLOYEE_LIST_SUCCESS: "GET_EMPLOYEE_LIST_SUCCESS",
  GET_EMPLOYEE_LIST_FAILURE: "GET_EMPLOYEE_LIST_FAILURE",

  GET_PROJECT_LIST_REQUEST: "GET_PROJECT_LIST_REQUEST",
  GET_PROJECT_LIST_SUCCESS: "GET_PROJECT_LIST_SUCCESS",
  GET_PROJECT_LIST_FAILURE: "GET_PROJECT_LIST_FAILURE",

  GET_TASK_LIST_REQUEST: "GET_TASK_LIST_REQUEST",
  GET_TASK_LIST_SUCCESS: "GET_TASK_LIST_SUCCESS",
  GET_TASK_LIST_FAILURE: "GET_TASK_LIST_FAILURE",

  GET_EMPLOYEE_BY_PROJECT_ID_REQUEST: "GET_EMPLOYEE_BY_PROJECT_ID_REQUEST",
  GET_EMPLOYEE_BY_PROJECT_ID_SUCCESS: "GET_EMPLOYEE_BY_PROJECT_ID_SUCCESS",
  GET_EMPLOYEE_BY_PROJECT_ID_FAILURE: "GET_EMPLOYEE_BY_PROJECT_ID_FAILURE",

  GET_EMPLOYEE_BY_USER_ID_REQUEST: "GET_EMPLOYEE_BY_USER_ID_REQUEST",
  GET_EMPLOYEE_BY_USER_ID_SUCCESS: "GET_EMPLOYEE_BY_USER_ID_SUCCESS",
  GET_EMPLOYEE_BY_USER_ID_FAILURE: "GET_EMPLOYEE_BY_USER_ID_FAILURE",

  GET_TASK_DETAILE_BY_USER_ID_REQUEST: "GET_TASK_DETAILE_BY_USER_ID_REQUEST",
  GET_TASK_DETAILE_BY_USER_ID_SUCCESS: "GET_TASK_DETAILE_BY_USER_ID_SUCCESS",
  GET_TASK_DETAILE_BY_USER_ID_FAILURE: "GET_TASK_DETAILE_BY_USER_ID_FAILURE",

  POST_EMPLOYEE_COMMENT_REQUEST: "POST_EMPLOYEE_COMMENT_REQUEST",
  POST_EMPLOYEE_COMMENT_SUCCESS: "POST_EMPLOYEE_COMMENT_SUCCESS",
  POST_EMPLOYEE_COMMENT_FAILURE: "POST_EMPLOYEE_COMMENT_FAILURE",

  UPDATE_EMPLOYEE_COMMENT_REQUEST: "UPDATE_EMPLOYEE_COMMENT_REQUEST",
  UPDATE_EMPLOYEE_COMMENT_SUCCESS: "UPDATE_EMPLOYEE_COMMENT_SUCCESS",
  UPDATE_EMPLOYEE_COMMENT_FAILURE: "UPDATE_EMPLOYEE_COMMENT_FAILURE",

  GET_EMPLOYEE_COMMENT_REQUEST: "GET_EMPLOYEE_COMMENT_REQUEST",
  GET_EMPLOYEE_COMMENT_SUCCESS: "GET_EMPLOYEE_COMMENT_SUCCESS",
  GET_EMPLOYEE_COMMENT_FAILURE: "GET_EMPLOYEE_COMMENT_FAILURE",

  DELETE_EMPLOYEE_COMMENT_REQUEST: "DELETE_EMPLOYEE_COMMENT_REQUEST",
  DELETE_EMPLOYEE_COMMENT_SUCCESS: "DELETE_EMPLOYEE_COMMENT_SUCCESS",
  DELETE_EMPLOYEE_COMMENT_FAILURE: "DELETE_EMPLOYEE_COMMENT_FAILURE",
};

const SIGN_UP_REQUEST = {
  CHECK_EXIST_ACCOUTN_REQUEST: "CHECK_EXIST_ACCOUTN_REQUEST",
  CHECK_EXIST_ACCOUTN_SUCCESS: "CHECK_EXIST_ACCOUTN_SUCCESS",
  CHECK_EXIST_ACCOUTN_FAILURE: "CHECK_EXIST_ACCOUTN_FAILURE",

  RESEND_OTP_REQUEST: "RESEND_OTP_REQUEST",
  RESEND_OTP_SUCCESS: "RESEND_OTP_SUCCESS",
  RESEND_OTP_FAILURE: "RESEND_OTP_FAILURE",

  CONFIRM_OTP_REQUEST: "CONFIRM_OTP_REQUEST",
  CONFIRM_OTP_SUCCESS: "CONFIRM_OTP_SUCCESS",
  CONFIRM_OTP_FAILURE: "CONFIRM_OTP_FAILURE",

  COMPLETE_PROFILE_REQUEST: "COMPLETE_PROFILE_REQUEST",
  COMPLETE_PROFILE_SUCCESS: "COMPLETE_PROFILE_SUCCESS",
  COMPLETE_PROFILE_FAILURE: "COMPLETE_PROFILE_FAILURE",

  SIGN_UP_PROFILE_REQUEST: "SIGN_UP_PROFILE_REQUEST",
  SIGN_UP_PROFILE_SUCCESS: "SIGN_UP_PROFILE_SUCCESS",
  SIGN_UP_PROFILE_FAILURE: "SIGN_UP_PROFILE_FAILURE",
};

const ORGANIZATION = {
  GET_ORGANIZATION_REQUEST: "GET_ORGANIZATION_REQUEST",
  GET_ORGANIZATION_SUCCESS: "GET_ORGANIZATION_SUCCESS",
  GET_ORGANIZATION_FAILURE: "GET_ORGANIZATION_FAILURE",

  ADD_ORGANIZATION_REQUEST: "ADD_ORGANIZATION_REQUEST",
  ADD_ORGANIZATION_SUCCESS: "ADD_ORGANIZATION_SUCCESS",
  ADD_ORGANIZATION_FAILURE: "ADD_ORGANIZATION_FAILURE",

  EDIT_ORGANIZATION_REQUEST: "EDIT_ORGANIZATION_REQUEST",
  EDIT_ORGANIZATION_SUCCESS: "EDIT_ORGANIZATION_SUCCESS",
  EDIT_ORGANIZATION_FAILURE: "EDIT_ORGANIZATION_FAILURE",

  DELETE_ORGANIZATION_REQUEST: "DELETE_ORGANIZATION_REQUEST",
  DELETE_ORGANIZATION_SUCCESS: "DELETE_ORGANIZATION_SUCCESS",
  DELETE_ORGANIZATION_FAILURE: "DELETE_ORGANIZATION_FAILURE",

  ACTIVE_ORGANIZATION_REQUEST: "ACTIVE_ORGANIZATION_REQUEST",
  ACTIVE_ORGANIZATION_SUCCESS: "ACTIVE_ORGANIZATION_SUCCESS",
  ACTIVE_ORGANIZATION_FAILURE: "ACTIVE_ORGANIZATION_FAILURE",

  SET_USER_ORGANIZATION_REQUEST: "SET_USER_ORGANIZATION_REQUEST",
  SET_USER_ORGANIZATION_SUCCESS: "SET_USER_ORGANIZATION_SUCCESS",
  SET_USER_ORGANIZATION_FAILURE: "SET_USER_ORGANIZATION_FAILURE",
};
const SPRINTS = {
  GET_SPRINT_REQUEST: "GET_SPRINT_REQUEST",
  GET_SPRINT_SUCCESS: "GET_SPRINT_SUCCESS",
  GET_SPRINT_FAILURE: "GET_SPRINT_FAILURE",

  ADD_SPRINT_REQUEST: "ADD_SPRINT_REQUEST",
  ADD_SPRINT_SUCCESS: "ADD_SPRINT_SUCCESS",
  ADD_SPRINT_FAILURE: "ADD_SPRINT_FAILURE",

  EDIT_SPRINT_REQUEST: "EDIT_SPRINT_REQUEST",
  EDIT_SPRINT_SUCCESS: "EDIT_SPRINT_SUCCESS",
  EDIT_SPRINT_FAILURE: "EDIT_SPRINT_FAILURE",

  DELETE_SPRINT_REQUEST: "DELETE_SPRINT_REQUEST",
  DELETE_SPRINT_SUCCESS: "DELETE_SPRINT_SUCCESS",
  DELETE_SPRINT_FAILURE: "DELETE_SPRINT_FAILURE",
};
const MANAGE_USER = {
  ADD_MANAGE_USER_REQUEST: "ADD_MANAGE_USER_REQUEST",
  ADD_MANAGE_USER_SUCCESS: "ADD_MANAGE_USER_SUCCESS",
  ADD_MANAGE_USER_FAILURE: "ADD_MANAGE_USER_FAILURE",

  GET_MANAGE_USER_REQUEST: "GET_MANAGE_USER_REQUEST",
  GET_MANAGE_USER_SUCCESS: "GET_MANAGE_USER_SUCCESS",
  GET_MANAGE_USER_FAILURE: "GET_MANAGE_USER_FAILURE",

  CHANGE_USER_STATUS_REQUEST: "CHANGE_USER_STATUS_REQUEST",
  CHANGE_USER_STATUS_SUCCESS: "CHANGE_USER_STATUS_SUCCESS",
  CHANGE_USER_STATUS_FAILURE: "CHANGE_USER_STATUS_FAILURE",

  EDIT_MANAGE_USER_REQUEST: "EDIT_MANAGE_USER_REQUEST",
  EDIT_MANAGE_USER_SUCCESS: "EDIT_MANAGE_USER_SUCCESS",
  EDIT_MANAGE_USER_FAILURE: "EDIT_MANAGE_USER_FAILURE",

  DELETE_MANAGE_USER_REQUEST: "DELETE_MANAGE_USER_REQUEST",
  DELETE_MANAGE_USER_SUCCESS: "DELETE_MANAGE_USER_SUCCESS",
  DELETE_MANAGE_USER_FAILURE: "DELETE_MANAGE_USER_FAILURE",
};

const QA_PROTOCOL = {
  CREAT_QA_PROTOCOL_REQUEST: "CREAT_QA_PROTOCOL_REQUEST",
  CREAT_QA_PROTOCOL_SUCCESS: "CREAT_QA_PROTOCOL_SUCCESS",
  CREAT_QA_PROTOCOL_FAILURE: "CREAT_QA_PROTOCOL_FAILURE",

  EDIT_QA_PROTOCOL_REQUEST: "EDIT_QA_PROTOCOL_REQUEST",
  EDIT_QA_PROTOCOL_SUCCESS: "EDIT_QA_PROTOCOL_SUCCESS",
  EDIT_QA_PROTOCOL_FAILURE: "EDIT_QA_PROTOCOL_FAILURE",

  GET_ALL_QA_PROTOCOL_REQUEST: "GET_ALL_QA_PROTOCOL_REQUEST",
  GET_ALL_QA_PROTOCOL_SUCCESS: "GET_ALL_QA_PROTOCOL_SUCCESS",
  GET_ALL_QA_PROTOCOL_FAILURE: "GET_ALL_QA_PROTOCOL_FAILURE",

  DELETE_QA_PROTOCOL_REQUEST: "DELETE_QA_PROTOCOL_REQUEST",
  DELETE_QA_PROTOCOL_SUCCESS: "DELETE_QA_PROTOCOL_SUCCESS",
  DELETE_QA_PROTOCOL_FAILURE: "DELETE_QA_PROTOCOL_FAILURE",

  QA_PROTOCOL_REPORT_REQUEST: "QA_PROTOCOL_REPORT_REQUEST",
  QA_PROTOCOL_REPORT_SUCCESS: "QA_PROTOCOL_REPORT_SUCCESS",
  QA_PROTOCOL_REPORT_FAILURE: "QA_PROTOCOL_REPORT_FAILURE",
};

const STICKY_NOTES = {
  CREATE_STICKY_NOTE_REQUEST: "CREATE_STICKY_NOTE_REQUEST",
  CREATE_STICKY_NOTE_SUCCESS: "CREATE_STICKY_NOTE_SUCCESS",
  CREATE_STICKY_NOTE_FAILURE: "CREAT_STICKY_NOTE_FAILURE",

  EDIT_STICKY_NOTE_REQUEST: "EDIT_STICKY_NOTE_REQUEST",
  EDIT_STICKY_NOTE_SUCCESS: "EDIT_STICKY_NOTE_SUCCESS",
  EDIT_STICKY_NOTE_FAILURE: "EDIT_STICKY_NOTE_FAILURE",

  GET_ALL_STICKY_NOTES_REQUEST: "GET_ALL_STICKY_NOTES_REQUEST",
  GET_ALL_STICKY_NOTES_SUCCESS: "GET_ALL_STICKY_NOTES_SUCCESS",
  GET_ALL_STICKY_NOTES_FAILURE: "GET_ALL_STICKY_NOTES_FAILURE",

  DELETE_STICKY_NOTE_REQUEST: "DELETE_STICKY_NOTE_REQUEST",
  DELETE_STICKY_NOTE_SUCCESS: "DELETE_STICKY_NOTE_SUCCESS",
  DELETE_STICKY_NOTE_FAILURE: "DELETE_STICKY_NOTE_FAILURE",
};

const TEAM_SCHEDULER = {
  GET_TEAM_SCHEDULER_REQUEST: "GET_TEAM_SCHEDULER_REQUEST",
  GET_TEAM_SCHEDULER_SUCCESS: "GET_TEAM_SCHEDULER_SUCCESS",
  GET_TEAM_SCHEDULER_FAILURE: "GET_TEAM_SCHEDULER_FAILURE",
};

const REPORT_REQUEST = {
  GET_MONTHLY_SUMMARY_PROJECTS_REPORT_REQUEST:
    "GET_MONTHLY_SUMMARY_PROJECTS_REPORT_REQUEST",
  GET_MONTHLY_SUMMARY_PROJECTS_REPORT_SUCCESS:
    "GET_MONTHLY_SUMMARY_PROJECTS_REPORT_SUCCESS",
  GET_MONTHLY_SUMMARY_PROJECTS_REPORT_FAILURE:
    "GET_MONTHLY_SUMMARY_PROJECTS_REPORT_FAILURE",

  GET_MONTHLY_SUMMARY_USERS_REPORT_REQUEST:
    "GET_MONTHLY_SUMMARY_USERS_REPORT_REQUEST",
  GET_MONTHLY_SUMMARY_USERS_REPORT_SUCCESS:
    "GET_MONTHLY_SUMMARY_USERS_REPORT_SUCCESS",
  GET_MONTHLY_SUMMARY_USERS_REPORT_FAILURE:
    "GET_MONTHLY_SUMMARY_USERS_REPORT_FAILURE",
};

export {
  request,
  success,
  failure,
  STICKY_NOTES,
  ORGANIZATION,
  MANAGE_USER,
  SIGN_UP_REQUEST,
  USER_REQUEST,
  UPDATE_USER,
  SCHEDULER_REQUEST,
  EXPENSE_REQUEST,
  INVOICE_REQUEST,
  INCOME_REQUEST,
  SALARY_REQUEST,
  PAYMENT_METHOD_REQUEST,
  PROJECT_REQUEST,
  EMPLOYEE_REQUEST,
  LEAVES_REQUEST,
  TASK_REQUEST,
  LOANS_REQUEST,
  PROVIDENT_FUND_REQUEST,
  ASSET_REQUEST,
  GENERAL_REQUEST,
  ALLOCATED_ASSETS_REQUEST,
  CLIENTS,
  FINANCE_DASHBOARD_REQUEST,
  DAILY_ATTENDANCE_REQUEST,
  ATTENDANCE_REQUEST,
  LATE_COMING_REQUEST,
  DEPARTMENTS,
  DEPARTMENT_TASK_CATEGORY,
  USER_LIST_REQUEST,
  TEAMS_REQUEST,
  SUGGESTION_REQUEST,
  HOLIDAYS,
  USER_ROLES,
  PROJECTSETTINGS,
  PROJECTCATEGORY,
  ATTENDANCE,
  TODO,
  TODO_LIST,
  FEEDBACK_REQUEST,
  PROJECTMILESTONE,
  PROJECT_BACKLOG,
  PROJECTINFO,
  BD_PROJECT_DATA_REQUEST,
  FILE,
  WORKLOAD_REQUEST,
  PROJECT_TEMPLATES_REQUEST,
  QA_PROTOCOL,
  SPRINTS,
  ZOOM,
  TEAM_SCHEDULER,
  REPORT_REQUEST,
};
